import { jsxs as g, jsx as t, Fragment as T } from "react/jsx-runtime";
import { U as Be, P as Ue, a as Re, c as D, L as Qe, M as ze, b as Je, d as pe, e as Ze, R, C as w, D as Xe, w as O, A as Fe, f as Ie, I as $, h as p, g as Oe, i as j, F as Ve, j as We, S as $e, k as _e, l as et, N as ye, m as K, n as W, T as tt, o as nt, p as lt, q as at } from "./vendor-dfL8El7Y.js";
import { B as Ol, r as Vl, y as ql, s as Pl, t as Ll, u as jl, v as Kl, x as Hl } from "./vendor-dfL8El7Y.js";
import k, { useState as E, useEffect as U, useRef as te, useCallback as X, useMemo as it } from "react";
import { Link as re } from "react-router-dom";
import st from "react-dom";
const H = ({
  placement: e,
  target: l,
  isOpen: n,
  title: r,
  content: a,
  toggle: s
}) => /* @__PURE__ */ g(
  Be,
  {
    trigger: "legacy",
    placement: e,
    target: l || "",
    ...n && { isOpen: n.value },
    ...s && { toggle: s },
    children: [
      r && /* @__PURE__ */ t(Ue, { children: r }),
      /* @__PURE__ */ t(Re, { children: a })
    ]
  }
), rt = ({ placement: e, target: l, content: n }) => /* @__PURE__ */ t(Be, { trigger: "legacy", placement: e, target: l, className: "error-popover", children: /* @__PURE__ */ t(Re, { children: n }) }), G = ({
  id: e,
  mobileBig: l = !1,
  popover: n,
  secondary: r = !1,
  wrapperClassName: a,
  wrapperStyle: s = { display: "inline" },
  floatRight: c,
  withError: i = !1,
  label: d = "Button",
  type: o = "button",
  ...u
}) => {
  let f = (u.className || "") + " btn";
  return f.indexOf("btn-") === -1 && (f += " btn-info"), r && (f += " btn-square"), l && (f += " btn-mobile-big"), c && (f += " float-md-right"), /* @__PURE__ */ g(T, { children: [
    /* @__PURE__ */ t("div", { className: a, style: s, children: /* @__PURE__ */ t(
      "button",
      {
        ...u,
        className: f,
        id: e,
        onClick: n && n.toggle || u.onClick,
        type: o,
        children: u.children || d
      }
    ) }),
    !i && e && n && /* @__PURE__ */ t(
      H,
      {
        content: n.content,
        placement: n.placement,
        target: e,
        title: n.title,
        isOpen: n.isOpen
      }
    ),
    i && e && n && /* @__PURE__ */ t(
      rt,
      {
        content: n.content,
        isOpen: n.isOpen,
        placement: n.placement,
        target: e,
        title: n.title,
        toggle: n.toggle
      }
    )
  ] });
}, Ln = ({
  id: e,
  onAdd: l,
  label: n = "Lisa",
  popoverContent: r,
  popoverOpen: a,
  popoverPlacement: s = "top-start",
  popoverTitle: c,
  popoverToggle: i,
  secondary: d = !1,
  submit: o = !1,
  popoverReactstrap: u,
  disabled: f,
  isRemove: A,
  className: M
}) => {
  const b = D(
    "btn-info" + (A ? " btn-with-minus" : " btn-with-plus") + (d ? " btn-square" : ""),
    M
  );
  return /* @__PURE__ */ t(
    G,
    {
      type: o ? "submit" : "button",
      disabled: f,
      className: b,
      id: e,
      onClick: r ? i : l,
      popover: {
        arrowPointAtCenter: !0,
        // NB not used in main Button
        content: r,
        isOpen: { value: !!a },
        placement: s,
        title: c || "",
        toggle: i,
        popoverReactstrap: u
        // NB not used in main Button
      },
      children: n
    }
  );
}, jn = ({
  className: e,
  id: l,
  label: n,
  popover: r,
  wrapperStyle: a = { display: "inline" },
  ...s
}) => {
  const c = D("btn-light btn-multiple-options", e);
  return /* @__PURE__ */ t("div", { style: a, children: /* @__PURE__ */ t(G, { className: c, id: l, onClick: r && r.toggle || s.onClick, popover: r, children: n }) });
}, Kn = ({ onClick: e }) => /* @__PURE__ */ t("a", { className: "badge badge-info badge-small", onClick: e }), ct = ({ className: e, secondary: l, ...n }) => {
  const r = D("btn-danger" + (l ? " btn-square" : ""), e);
  return /* @__PURE__ */ t(G, { ...n, className: r });
}, Ce = ({ onClick: e, secondary: l, ...n }) => {
  const r = D(l ? " btn-square" : "", n.className);
  return /* @__PURE__ */ t(G, { ...n, className: r, onClick: e });
}, ne = ({
  color: e = "#015477",
  size: l = 16,
  delay: n = 500,
  type: r = "spokes",
  style: a
}) => /* @__PURE__ */ t("div", { style: a, children: /* @__PURE__ */ t(Qe, { color: e, type: r, delay: n, width: l, height: l }) }), le = ({
  children: e,
  className: l,
  id: n,
  label: r,
  popoverContent: a,
  popoverOpen: s,
  popoverPlacement: c = "bottom-start",
  popoverTitle: i,
  popoverToggle: d,
  short: o,
  withInfo: u = !1,
  wrapperStyle: f = { display: "inline" },
  ...A
}) => {
  const [M, b] = E(!1), h = () => {
    b((v) => !v);
  }, m = D(
    {
      "badge-with-icon": !o,
      "badge-small": o
    },
    l
  );
  return /* @__PURE__ */ g("div", { style: f, children: [
    o && /* @__PURE__ */ t("span", { className: m, id: n }),
    u && !o && /* @__PURE__ */ g(T, { children: [
      /* @__PURE__ */ t("button", { className: m, id: n, onClick: a && d || h, style: { cursor: "pointer" }, ...A, children: r || e }),
      /* @__PURE__ */ t(
        H,
        {
          className: "for-badge",
          content: a,
          isOpen: { value: s || M },
          placement: c,
          target: n,
          title: i,
          toggle: d || h
        }
      )
    ] }),
    !u && !o && /* @__PURE__ */ t("span", { className: m, id: n, children: r || e })
  ] });
}, qe = ({
  children: e,
  label: l = "Orange",
  id: n,
  short: r = !1,
  popoverPlacement: a = "bottom",
  ...s
}) => /* @__PURE__ */ g("div", { children: [
  /* @__PURE__ */ t(
    le,
    {
      ...s,
      className: "badge badge-warning2",
      id: n,
      label: l,
      short: r,
      popoverPlacement: a
    }
  ),
  e
] }), ke = ({ onEdit: e, children: l, loading: n, popover: r, status: a }) => /* @__PURE__ */ g(
  ze,
  {
    close: (e || r) && /* @__PURE__ */ g("span", { children: [
      e && /* @__PURE__ */ t("a", { href: "javascript:void(0);", className: "icon-edit", onClick: e }),
      r && /* @__PURE__ */ g(T, { children: [
        /* @__PURE__ */ t("a", { href: "javascript:void(0);", className: "icon-info", id: r.target }),
        /* @__PURE__ */ t(H, { ...r })
      ] })
    ] }),
    children: [
      l,
      n && /* @__PURE__ */ t(ne, { style: { marginLeft: "10px" }, delay: 200, size: 20 }),
      a && /* @__PURE__ */ t(qe, { wrapperStyle: { marginLeft: "1rem" }, label: a })
    ]
  }
), de = {
  et: {
    header: "Kas olete kindel, et soovite selle rea kustutada?",
    description: "Kustutatud ridu ei ole võimalik hiljem taastada.",
    discardBtnLabel: "Loobun",
    confirmBtnLabel: "Kustutan"
  },
  en: {
    header: "Are you sure that you would like to delete this row?",
    description: "Deleted rows cannot be restored.",
    discardBtnLabel: "Cancel",
    confirmBtnLabel: "Delete"
  },
  ru: {
    header: "Вы уверены в том, что хотите удалить эту строку?",
    description: "Удаленные строки невозможно восстановить.",
    discardBtnLabel: "Отменить",
    confirmBtnLabel: "Удалить"
  }
}, ot = ({
  locale: e = "et",
  onCancel: l,
  onConfirm: n,
  confirmationText: r
}) => /* @__PURE__ */ g(Je, { size: "sm", isOpen: !0, toggle: l, children: [
  r ? /* @__PURE__ */ t(ke, { children: r }) : /* @__PURE__ */ t(ke, { children: de[e].header }),
  /* @__PURE__ */ t(pe, { children: de[e].description }),
  /* @__PURE__ */ g(Ze, { children: [
    /* @__PURE__ */ t(Ce, { className: "mx-1", onClick: l, children: de[e].discardBtnLabel }),
    /* @__PURE__ */ t(ct, { className: "btn_prm_red", onClick: n, children: de[e].confirmBtnLabel })
  ] })
] }), dt = ({
  className: e,
  label: l = "Kustutan",
  locale: n = "et",
  onConfirm: r,
  tag: a,
  confirmationText: s
}) => {
  const [c, i] = E(!1), d = () => {
    i((A) => !A);
  }, o = () => {
    i(!1), r();
  }, u = D("icon-delete", e);
  return /* @__PURE__ */ g("div", { style: { display: "inline" }, children: [
    /* @__PURE__ */ t(a || "a", { href: "javascript:void(0);", className: u, onClick: d, "aria-label": "Kustutan", children: a && l || "" }),
    c && /* @__PURE__ */ t(
      ot,
      {
        locale: n,
        onCancel: d,
        onConfirm: o,
        confirmationText: s
      }
    )
  ] });
}, mt = ({ redirectTo: e, onClick: l }) => e ? /* @__PURE__ */ t(re, { className: "icon-edit", to: e }) : /* @__PURE__ */ t("a", { href: "javascript:void(0);", className: "icon-edit", onClick: l, "aria-label": "Muudan" }), Hn = ({ onClick: e }) => /* @__PURE__ */ t(
  "a",
  {
    className: "icon-edit",
    href: "javascript:void(0);",
    onClick: e,
    style: {
      right: "0",
      position: "absolute",
      paddingRight: "1.5rem"
    }
  }
), ut = ({
  iconName: e,
  isSmall: l,
  redirectTo: n,
  redirectLinkToNewTab: r,
  onClick: a,
  type: s,
  popover: c,
  id: i,
  style: d,
  tooltip: o,
  tooltipClassName: u
}) => {
  if (n)
    return /* @__PURE__ */ t(
      re,
      {
        className: e + (l ? " small-icon" : ""),
        to: n,
        target: r ? "_blank" : void 0
      }
    );
  const f = D(e, { "small-icon": l }, u);
  return /* @__PURE__ */ g(T, { children: [
    /* @__PURE__ */ t(
      "button",
      {
        style: {
          ...d ?? {},
          background: "none",
          border: "none",
          padding: "0",
          fontFamily: "arial, sans-serif",
          color: "#069",
          textDecoration: "underline",
          cursor: "pointer",
          display: "inline-block",
          maxHeight: "15px"
        },
        tabIndex: -1,
        type: s || "button",
        ...i && { id: i },
        children: /* @__PURE__ */ t(
          "a",
          {
            tabIndex: 0,
            className: f,
            onClick: c && c.toggle || a,
            ...o && { "tooltip-title": o }
          }
        )
      }
    ),
    i && c && /* @__PURE__ */ t(
      H,
      {
        content: c.content,
        placement: c.placement,
        target: i,
        title: c.title,
        isOpen: c.isOpen
      }
    )
  ] });
}, Gn = ({ path: e, onClick: l }) => /* @__PURE__ */ t(re, { className: "icon-search", to: e || "#", onClick: l, "aria-label": e || "#" }), Un = (e) => /* @__PURE__ */ t(G, { ...e, className: "btn-sm btn-cancel", label: "", type: "reset" }), Qn = ({ onClick: e, type: l = "submit", ...n }) => /* @__PURE__ */ t(G, { ...n, onClick: e, type: l, className: "btn-sm btn-save", label: "" }), ht = ({ secondary: e, label: l = "Salvestan", ...n }) => {
  const r = D(
    {
      "btn-success": !0,
      "btn-square": e
    },
    n.className
  );
  return /* @__PURE__ */ t(G, { ...n, label: l, className: r });
}, zn = ({
  children: e,
  id: l,
  label: n,
  short: r,
  className: a,
  wrappingClassName: s,
  ...c
}) => {
  const i = D("badge badge-success", a);
  return /* @__PURE__ */ g("div", { className: s, children: [
    /* @__PURE__ */ t(le, { ...c, className: i, id: l, label: n, short: r }),
    e
  ] });
}, Jn = ({
  className: e,
  popover: l,
  wrapperStyle: n = { display: "inline" },
  ...r
}) => {
  const a = D("icon-print", e);
  return /* @__PURE__ */ t("div", { style: n, children: l ? /* @__PURE__ */ g(T, { children: [
    /* @__PURE__ */ t("a", { ...r, className: a, onClick: l.toggle || r.onClick }),
    /* @__PURE__ */ t(H, { ...l, content: l.content, target: r.id, title: l.title })
  ] }) : /* @__PURE__ */ t("a", { ...r, className: a }) });
}, gt = ({
  children: e,
  label: l = "Red",
  id: n,
  short: r = !1,
  ...a
}) => /* @__PURE__ */ g("div", { children: [
  /* @__PURE__ */ t(le, { ...a, className: "badge badge-danger", id: n, label: l, short: r }),
  e
] }), pn = ({
  children: e,
  label: l = "Gray",
  id: n,
  short: r = !1,
  ...a
}) => /* @__PURE__ */ g("div", { children: [
  /* @__PURE__ */ t(le, { ...a, className: "badge badge-default", id: n, label: l, short: r }),
  e
] }), Zn = ({
  children: e,
  label: l = "Yellow",
  id: n,
  short: r = !1,
  popoverPlacement: a = "bottom",
  ...s
}) => /* @__PURE__ */ g("div", { children: [
  /* @__PURE__ */ t(
    le,
    {
      ...s,
      className: "badge badge-warning",
      id: n,
      label: l,
      short: r,
      popoverPlacement: a
    }
  ),
  e
] }), ft = ({
  children: e,
  label: l = "Blue",
  id: n,
  short: r = !1,
  ...a
}) => /* @__PURE__ */ g("div", { children: [
  /* @__PURE__ */ t(le, { ...a, className: "badge badge-info", id: n, label: l, short: r }),
  e
] }), Xn = ({ additionFunction: e, added: l, addText: n, addedText: r }) => {
  const [a, s] = E(l), [c, i] = E(), d = (o, u) => {
    i({ label: o, content: u });
  };
  return c ? /* @__PURE__ */ t(
    gt,
    {
      id: "redbtn",
      label: c.label,
      popoverContent: c.content,
      withInfo: !0,
      popoverTitle: c.label
    }
  ) : /* @__PURE__ */ t(T, { children: a ? /* @__PURE__ */ t(ft, { id: "bluebtn", label: r || "Lisatud", withInfo: !1 }) : /* @__PURE__ */ t(
    G,
    {
      onClick: () => {
        e(d), s(!0);
      },
      secondary: !0,
      label: n || "Lisa"
    }
  ) });
}, bt = ({ children: e, sideCol: l = 5, centerCol: n = 10 }) => /* @__PURE__ */ g(R, { children: [
  /* @__PURE__ */ t(w, { lg: l, md: l, sm: 0, xl: l }),
  /* @__PURE__ */ t(w, { lg: n, md: n, sm: 20, style: { textAlign: "center" }, xl: n, children: e }),
  /* @__PURE__ */ t(w, { lg: l, md: l, sm: 0, xl: l })
] }), At = { textDecoration: "underline", cursor: "pointer" }, Wn = ({ children: e, label: l, noIcon: n, onDownload: r, className: a }) => /* @__PURE__ */ t(
  "a",
  {
    className: D({ "icon-download": !n }, a),
    onClick: r,
    style: { ...n ? At : {} },
    children: l || e
  }
), $n = ({ style: e, children: l }) => /* @__PURE__ */ t("div", { className: "draggable-area", style: { ...e, position: e?.position || "relative" }, children: l }), Mt = ({
  draggable: e,
  filterable: l,
  onToggleFilter: n,
  preferencesEnabled: r,
  onEdit: a,
  isLocked: s,
  customButtons: c
}) => /* @__PURE__ */ g("div", { className: "section-tools", style: { display: "flex", marginLeft: "auto" }, children: [
  c && c.map((i) => /* @__PURE__ */ t(
    G,
    {
      className: "mr-1",
      label: i.label,
      onClick: i.onClick,
      disabled: i.disabled,
      title: i.title
    },
    i.label
  )),
  l && /* @__PURE__ */ t(
    "a",
    {
      href: "javascript:void(0);",
      className: "icon-settings",
      onClick: n,
      "data-title": "Veergude valik",
      "aria-label": "Veergude valik"
    }
  ),
  r && /* @__PURE__ */ t("a", { href: "javascript:void(0);", className: "icon-preferences" }),
  e && /* @__PURE__ */ t("a", { href: "javascript:void(0);", className: "icon-drag" }),
  !s && a && /* @__PURE__ */ t("a", { href: "javascript:void(0);", className: "icon-edit ml-2", onClick: a }),
  s && /* @__PURE__ */ t("a", { className: "icon-lock", style: { pointerEvents: "none" } })
] }), Pe = ({
  children: e = /* @__PURE__ */ t("div", {}),
  collapsable: l = !1,
  form: n = !1,
  hideTitle: r = !1,
  noMarginTop: a = !1,
  title: s = "",
  withPreferences: c,
  withSettings: i = !1,
  collapsed: d,
  ...o
}) => {
  const [u, f] = E(d);
  U(() => {
    d || f(!1);
  }, [d]);
  const A = () => {
    f((b) => {
      const h = !b;
      return o.trackState?.({ collapsed: h }), h;
    });
  }, M = o.withCollapseIcon ? `section-collapse ${u ? "collapsed" : ""}` : "";
  return /* @__PURE__ */ g("section", { style: a ? { marginTop: "0" } : void 0, className: o.styleClass, children: [
    !r && /* @__PURE__ */ g("div", { className: "section-title", style: { clear: "both" }, children: [
      l && /* @__PURE__ */ t(
        "a",
        {
          href: "javascript:void(0);",
          "aria-expanded": !u,
          className: `${M} ${o.headerClass}`,
          onClick: A,
          children: /* @__PURE__ */ t("h3", { children: s })
        }
      ),
      !l && /* @__PURE__ */ t("h3", { children: s }),
      o.status && /* @__PURE__ */ t(qe, { label: o.status }),
      n && /* @__PURE__ */ t("div", { className: "title-line" }),
      i && !u && /* @__PURE__ */ t(
        Mt,
        {
          draggable: o.draggable,
          onEdit: o.onEdit,
          isLocked: o.isLocked,
          filterable: o.filterable,
          onToggleFilter: o.onToggleFilter,
          preferencesEnabled: c,
          customButtons: o.customButtons
        }
      ),
      o.loading && /* @__PURE__ */ t(ne, { delay: 200, size: 20 })
    ] }),
    (!l || !u) && /* @__PURE__ */ t("div", { className: n ? "form-section" : "section", children: e })
  ] });
}, _n = ({
  axis: e = "y",
  bounds: l = ".draggable-area",
  children: n,
  handle: r = ".icon-drag",
  title: a,
  headerClass: s,
  styleClass: c,
  withCollapseIcon: i
}) => /* @__PURE__ */ t(Xe, { axis: e, bounds: l, handle: r, children: /* @__PURE__ */ t("section", { children: /* @__PURE__ */ t(
  Pe,
  {
    draggable: !0,
    title: a,
    withSettings: !0,
    headerClass: s,
    styleClass: c,
    withCollapseIcon: i,
    children: n
  }
) }) }), vt = ({
  children: e,
  dismissible: l = !1,
  onDismiss: n,
  header: r,
  messages: a,
  theme: s = "info"
}) => {
  const [c, i] = E("show"), d = (o) => {
    o.preventDefault(), i("d-none"), n?.();
  };
  return /* @__PURE__ */ g("div", { className: `alert alert-${s} w-100 fade ${c}`, children: [
    l && /* @__PURE__ */ t("a", { "aria-label": "Sulgen", className: "close icon-close", href: "#", onClick: d, tabIndex: 0 }),
    r && /* @__PURE__ */ t("h3", { className: "alert-heading", children: r }),
    a && a.length > 0 && /* @__PURE__ */ t("ul", { children: a.map((o, u) => /* @__PURE__ */ t("li", { children: o }, u)) }),
    e && /* @__PURE__ */ t("div", { className: "mb-0", children: e })
  ] });
}, Se = (e) => /* @__PURE__ */ t(vt, { ...e, theme: "danger" }), we = ({ children: e }) => /* @__PURE__ */ t("div", { className: "form-control-feedback", style: { display: "table" }, children: e }), _ = 20, q = ({
  className: e,
  component: l,
  errorMessage: n,
  label: r,
  labelAfter: a,
  labelCol: s = { sm: 20, md: 6, xl: 6 },
  labelInfo: c,
  labelStyle: i,
  info: d,
  name: o,
  isErrorScrollDisabled: u = !1,
  popover: f,
  inline: A,
  labelClass: M,
  inputClass: b,
  isOnlyOneFieldRequired: h
}) => {
  const m = D(A ? "form-inline" : "form-group", e, {
    "has-danger": n || i && !h,
    "no-scroll": u
  }), N = `col-sm-${s.sm} col-md-${s.md} col-xl-${s.xl}`;
  let v;
  return f ? r ? v = `col-sm-${s.sm - 2} col-md-${_ - s.md - 2} col-xl-${_ - s.xl - 2} popoverSibling` : v = `col-sm-18 col-md-${_ - 2} col-xl-${_ - 2} popoverSibling` : r ? v = `col-sm-${s.sm} col-md-${_ - s.md} col-xl-${_ - s.xl}` : v = "col-sm-20", /* @__PURE__ */ g("div", { className: m + " row", children: [
    r && /* @__PURE__ */ g("label", { className: "col-form-label " + (M || N), htmlFor: o, children: [
      r,
      c && /* @__PURE__ */ t("div", { className: i || "label-comment", children: c }),
      d && /* @__PURE__ */ g(T, { children: [
        /* @__PURE__ */ t("a", { href: "javascript:void(0);", className: "icon-info light-icon small-icon pl-1", id: `${o}-tooltip` }),
        /* @__PURE__ */ t(H, { content: d.content, target: `${o}-tooltip`, title: d.title })
      ] })
    ] }),
    /* @__PURE__ */ g("div", { className: b || v, children: [
      l,
      a && /* @__PURE__ */ t("span", { children: a }),
      n && /* @__PURE__ */ t(we, { children: n })
    ] }),
    f && /* @__PURE__ */ g("div", { className: "col-sm-2 col-md-2 col-xl-2", children: [
      /* @__PURE__ */ t(
        "a",
        {
          href: "javascript:void(0);",
          className: "icon-info light-icon small-icon",
          id: f.target,
          "aria-label": f.target
        }
      ),
      /* @__PURE__ */ t(H, { ...f })
    ] })
  ] });
}, me = 3, ve = 0, Nt = ({ paginator: e, onPagination: l }) => {
  const [n, r] = E(e?.pageSize || 5), [a, s] = E(
    e ? Math.floor(e.elementOffset / e.pageSize) : 0
  );
  U(() => {
    if (e) {
      e.pageSize !== n && r(e.pageSize);
      const m = Math.floor(e.elementOffset / e.pageSize);
      m !== a && s(m);
    }
  }, [e, n, a]);
  const c = (m) => {
    s(m), l?.({
      pageSize: n,
      elementOffset: m * n
    });
  };
  if (!e.numberOfElements || !e.totalElements)
    return /* @__PURE__ */ t("div", {});
  const { numberOfElements: i, totalElements: d, elementOffset: o } = e, u = Math.ceil(d / n), f = a === ve, A = u === a + 1, M = `${o + 1}-${o + i}/${d}`, b = u > 1;
  return /* @__PURE__ */ g("div", { className: "pagination-block", children: [
    /* @__PURE__ */ t("div", { className: "pagination-total", children: M }),
    b && /* @__PURE__ */ t("div", { "aria-label": "Page navigation", className: "pagination-list", children: /* @__PURE__ */ g("ul", { className: "pagination", children: [
      /* @__PURE__ */ t("li", { className: "page-item d-none d-md-inline", children: /* @__PURE__ */ g(
        "button",
        {
          "aria-label": "First",
          className: `btn-outline-primary page-link arrow ${f ? "disabled" : ""}`,
          onClick: () => !f && c(ve),
          children: [
            "| ",
            /* @__PURE__ */ t("span", { children: "‹‹" })
          ]
        }
      ) }),
      /* @__PURE__ */ t("li", { className: "page-item", children: /* @__PURE__ */ t(
        "button",
        {
          "aria-label": "Previous",
          className: `btn-outline-primary page-link arrow ${f ? "disabled" : ""}`,
          onClick: () => !f && c(a - 1),
          children: /* @__PURE__ */ t("span", { children: "‹" })
        }
      ) }),
      (() => {
        const m = [];
        if (b) {
          const N = a - me, v = a + me;
          for (let y = ve; y < u; y++)
            (y <= v && y >= N || y <= me || y > u - me) && m.push(
              /* @__PURE__ */ t("li", { className: "page-item", children: /* @__PURE__ */ t(
                "button",
                {
                  className: `page-link btn-outline-primary ${y === a ? "current" : ""}`,
                  onClick: () => c(y),
                  children: y + 1
                }
              ) }, `page-link-${y}`)
            ), (y === N - 1 || y === v + 1) && m.push(
              /* @__PURE__ */ t("li", { className: "page-item", children: /* @__PURE__ */ t("button", { className: "page-link interval btn-outline-primary", children: "..." }) }, `page-link-interval-${y}`)
            );
        }
        return m;
      })(),
      /* @__PURE__ */ t("li", { className: "page-item", children: /* @__PURE__ */ t(
        "button",
        {
          "aria-label": "Next",
          className: `btn-outline-primary page-link arrow ${A ? "disabled" : ""}`,
          onClick: () => !A && c(a + 1),
          children: /* @__PURE__ */ t("span", { children: "›" })
        }
      ) }),
      /* @__PURE__ */ t("li", { className: "page-item d-none d-md-inline", children: /* @__PURE__ */ g(
        "button",
        {
          "aria-label": "Last",
          className: `btn-outline-primary page-link arrow ${A ? "disabled" : ""}`,
          onClick: () => !A && c(u - 1),
          children: [
            /* @__PURE__ */ t("span", { children: "››" }),
            " |"
          ]
        }
      ) })
    ] }) })
  ] });
}, xe = ({
  header: e,
  id: l,
  children: n,
  customEditRowComponent: r,
  locale: a = "et",
  onEdit: s,
  onDelete: c,
  redirectOnEdit: i
}) => /* @__PURE__ */ t("td", { headers: e, id: l, children: n || r || /* @__PURE__ */ g("div", { children: [
  /* @__PURE__ */ t(mt, { onClick: s, redirectTo: i }),
  c && /* @__PURE__ */ t(dt, { locale: a, onConfirm: c })
] }) }), be = (e) => e?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().replace(/\s+/g, "-").toLowerCase(), ge = (e, l, n) => {
  let r = "table=" + e + "-rowcol=";
  return l ? r += be(l) : r += "header" + n;
}, ue = (e, l, n) => he(e, n) + "-rowCol=" + be(l), he = (e, l) => "subTableFor=" + e + "-mainTableRow=" + l, Ye = (e, l) => e ? /* @__PURE__ */ t(e, { ...l }) : null, It = ({
  tableId: e,
  headers: l,
  rowNr: n,
  customEditRowComponent: r,
  data: a,
  editable: s,
  rowId: c,
  rowId2: i,
  locale: d = "et",
  onDelete: o,
  onEdit: u,
  redirectOnEdit: f,
  tableContainsButtons: A,
  subHeaders: M,
  subContent: b,
  subTogglers: h,
  subEditable: m,
  subCustomEditRowComponent: N,
  subRowIds: v,
  wrapBigColumns: y,
  isCustomColorRow: x,
  openByDefault: Y = !1
}) => {
  const [P, L] = E(!!Y), B = s || a?.props && a.props?.showRowEditButtons, F = m || a?.props && a.props?.showRowEditButtons, Q = typeof h == "string" ? [h] : h, I = (C) => {
    L(typeof C == "boolean" ? C : !P);
  }, V = B && /* @__PURE__ */ t(
    xe,
    {
      customEditRowComponent: r && Ye(r, {
        data: a,
        rowId: c,
        rowId2: i,
        onDelete: o,
        onEdit: u,
        toggleShow: I
      }),
      id: "tableId=" + e + "rowId=" + n + "colId=" + l?.length,
      header: ge(e, "headerEditable"),
      locale: d,
      onDelete: o ? () => o(a) : void 0,
      onEdit: () => u?.(a),
      redirectOnEdit: f
    }
  ), ie = !B && A && /* @__PURE__ */ t("td", {});
  let Z = "";
  return a?.props?.isEditing && (Z = "edit"), x && (Z = "custom-color"), /* @__PURE__ */ g(T, { children: [
    /* @__PURE__ */ g("tr", { className: Z, children: [
      a && Object.keys(a).filter((C) => C !== "props").map((C, S) => {
        const z = a[C], se = y && typeof z == "string" && z.split("").length > 14 ? "wrapped" : void 0, Me = Y || Q && Q.some((oe) => oe === C) ? /* @__PURE__ */ t("a", { href: "javascript:void(0);", onClick: I, children: z }) : z, ce = `tableId=${e}rowId=${n}colId=${S}`;
        return /* @__PURE__ */ t(
          "td",
          {
            headers: ge(e, l?.at(S), S),
            id: ce,
            className: se,
            children: Me
          },
          C
        );
      }),
      V || ie
    ] }),
    b && b.length > 0 && /* @__PURE__ */ t("tr", { style: { display: P ? "table-row" : "none" }, children: /* @__PURE__ */ t("td", { colSpan: a && Object.keys(a).length, children: /* @__PURE__ */ g(fe, { id: he(e, n), children: [
      M && /* @__PURE__ */ t("thead", { children: /* @__PURE__ */ g("tr", { style: { borderTop: "none" }, children: [
        M.map((C) => /* @__PURE__ */ t("th", { id: ue(e, C, n), children: C }, C)),
        m && /* @__PURE__ */ t("th", { id: ue(e, "subHeader=headerEditable", n) })
      ] }) }),
      /* @__PURE__ */ t("tbody", { children: b.map((C, S) => {
        const z = v && v[S], se = F && /* @__PURE__ */ t(
          xe,
          {
            customEditRowComponent: N && Ye(N, {
              data: a,
              subRowId: z,
              onDelete: o,
              onEdit: u,
              toggleShow: I
            }),
            id: he(e, n) + "-subrowId=" + S + "-subcolId=" + M?.length,
            header: ue(e, "subHeader=headerEditable", n),
            locale: d,
            onDelete: o ? () => o(a) : void 0,
            onEdit: () => u?.(a),
            redirectOnEdit: f
          }
        ), Me = !F && A && /* @__PURE__ */ t("td", {});
        return /* @__PURE__ */ g("tr", { className: Z, children: [
          Object.keys(C).map((ce, oe) => {
            let Ee = "";
            M !== void 0 && (Ee = "subHeader=" + be(M.at(oe)));
            const Ge = he(e, n) + "-subrowId=" + S + "-subcolId=" + oe;
            return /* @__PURE__ */ t("td", { headers: ue(e, Ee, n), id: Ge, children: C[ce] }, ce);
          }),
          se || Me
        ] }, S);
      }) })
    ] }) }) })
  ] });
}, yt = 20, ae = ({
  component: e,
  errorMessage: l,
  label: n,
  labelAfter: r,
  labelInfo: a,
  labelStyle: s,
  name: c,
  isErrorScrollDisabled: i = !1,
  isErrorScrollDisabledShow: d,
  popover: o
}) => {
  const u = D("form-group", {
    "has-danger": l || s,
    "no-scroll": i,
    "no-scroll-show": d
  });
  let f;
  if (o) {
    const A = yt - 4;
    f = `col-sm-16 col-md-${A} col-lg-${A} col-xl-${A} popoverSibling`;
  } else
    f = "col-sm-20";
  return /* @__PURE__ */ g("div", { className: u, children: [
    n && /* @__PURE__ */ g("label", { htmlFor: c, children: [
      n,
      a && /* @__PURE__ */ t("span", { className: s || "label-comment-vertical", children: a })
    ] }),
    o ? /* @__PURE__ */ g("div", { className: "row", children: [
      /* @__PURE__ */ t("div", { className: f, children: e }),
      /* @__PURE__ */ g("div", { className: "col-sm-2 col-md-2 col-lg-2 col-xl-2 pl-2", children: [
        /* @__PURE__ */ t("a", { href: "javascript:void(0);", className: "icon-info light-icon small-icon", id: o.target }),
        /* @__PURE__ */ t(H, { ...o })
      ] })
    ] }) : e,
    r && /* @__PURE__ */ t("span", { children: r }),
    l && /* @__PURE__ */ t(we, { children: l })
  ] });
}, Ct = (e) => {
  const {
    customErrorMessage: l,
    isErrorScrollDisabled: n,
    isVertical: r,
    loadOptions: a,
    label: s,
    showError: c,
    showRequired: i,
    setValue: d,
    value: o,
    disabled: u,
    errorMessage: f,
    required: A
  } = e, h = {
    component: /* @__PURE__ */ t(
      Fe,
      {
        ...e,
        loadOptions: a,
        className: "select-autocomplete",
        isDisabled: u,
        isMulti: !1,
        onChange: (m) => {
          const N = m === null || m.constructor === Array;
          d(N ? null : m);
        },
        value: o,
        required: !!A
      }
    ),
    isErrorScrollDisabled: n,
    errorMessage: l ? l() : f,
    hasError: c,
    isRequired: i,
    label: s
  };
  return r ? /* @__PURE__ */ t(ae, { ...h }) : /* @__PURE__ */ t(q, { ...h });
}, el = O(Ct), tl = ({ children: e }) => /* @__PURE__ */ t("div", { className: "form-footer", children: e }), Le = ({
  checked: e = !1,
  label: l,
  name: n,
  disabled: r,
  onChange: a,
  popover: s,
  style: c,
  value: i,
  ...d
}) => /* @__PURE__ */ g(T, { children: [
  /* @__PURE__ */ g(Ie, { className: "custom-control custom-checkbox", style: c, children: [
    /* @__PURE__ */ t(
      $,
      {
        ...d,
        checked: e,
        "aria-label": "checkbox",
        className: "custom-control-input",
        disabled: r,
        name: n,
        onChange: () => {
          a?.(!e);
        },
        type: "checkbox",
        value: i === void 0 ? void 0 : String(i)
      }
    ),
    /* @__PURE__ */ t("span", { className: "custom-control-indicator" }),
    l && /* @__PURE__ */ t("span", { className: "custom-control-description", children: l })
  ] }),
  s && /* @__PURE__ */ g("div", { style: { marginLeft: "20px" }, children: [
    /* @__PURE__ */ t("a", { className: "icon-info light-icon small-icon", id: s.target }),
    /* @__PURE__ */ t(H, { ...s })
  ] })
] }), ee = 20, Ae = ({
  className: e,
  component: l,
  errorMessage: n,
  label: r,
  labelArea: a,
  labelCol: s = { sm: 20, md: 6, lg: 6 },
  name: c,
  popover: i
}) => {
  const d = `form-group ${e || ""} ${n ? "has-danger" : ""}`, o = `col-sm-${s.sm} col-md-${s.md} col-lg-${s.lg} ${s.xl ? `col-xl-${s.xl}` : ""}`;
  let u;
  return i ? u = `col-sm-${s.sm - 2} col-md-${ee - s.md - 2} ${s.xl ? `col-xl-${ee - s.xl - 2}` : ""} popoverSibling` : u = `col-sm-${ee - s.sm} col-md-${ee - s.md} col-lg-${ee - s.lg} ${s.xl ? `col-xl-${ee - s.xl}` : ""}`, /* @__PURE__ */ g("div", { className: `${d} row`, children: [
    (r || a) && /* @__PURE__ */ t("label", { className: `col-form-label ${o}`, htmlFor: c, children: r || "" }),
    /* @__PURE__ */ g("div", { className: u, children: [
      l,
      n && /* @__PURE__ */ t(we, { children: n })
    ] }),
    i && /* @__PURE__ */ g("div", { className: "col-sm-2 col-md-2 col-xl-2", children: [
      /* @__PURE__ */ t("a", { href: "javascript:void(0);", className: "icon-info light-icon small-icon", id: i.target }),
      /* @__PURE__ */ t(H, { ...i })
    ] })
  ] });
}, wt = ({
  // Formsy injected props
  setValue: e,
  value: l,
  isFormSubmitted: n,
  isValid: r,
  showError: a,
  // Own props
  disabled: s,
  id: c,
  info: i,
  inlineEdit: d,
  label: o,
  labelArea: u = !0,
  labelCol: f,
  name: A,
  single: M = !0,
  update: b,
  unWrapped: h = !1,
  required: m,
  errorMessage: N,
  popover: v
}) => {
  const x = /* @__PURE__ */ t(
    Le,
    {
      checked: l,
      disabled: s,
      id: c,
      info: i,
      label: M ? void 0 : o,
      name: A,
      onChange: (P) => {
        e(P), b?.(A, P);
      },
      value: l
    }
  );
  return h ? x : /* @__PURE__ */ t(Ae, { ...{
    component: x,
    errorMessage: (n || l) && a && N,
    label: M && o,
    labelArea: u,
    labelCol: f,
    name: A,
    popover: v,
    labelInfo: m && "Kohustuslik",
    labelStyle: m && n && !r && "label-comment-error",
    inline: d
  } });
}, nl = O(wt), Et = (e) => {
  const [l, n] = E([]), r = "mta.";
  U(() => {
    const i = [];
    k.Children.forEach(e.children, (d) => {
      k.isValidElement(d) && d.props && d.props.value && i.push(d.props.name);
    }), n(i);
  }, [e.children]);
  const a = (i, d) => {
    n((o) => {
      const u = d ? [...o, i] : o.filter((f) => f !== i);
      return e.setValue(u), u;
    });
  }, s = () => e.isPristine ? "" : e.requiredCount && l.length < e.requiredCount ? e.translate && e.translate(`${r}checkboxGroupRequired`) : "", c = k.Children.map(e.children, (i, d) => {
    if (!k.isValidElement(i)) return i;
    const o = k.cloneElement(
      i,
      {
        labelCol: { sm: 0, md: 0, lg: 0 },
        update: a,
        labelArea: !1
      }
    );
    return /* @__PURE__ */ t(w, { md: d % 2 === 0 ? 7 : 13, sm: 20, children: o }, d);
  });
  return /* @__PURE__ */ t(Ae, { ...e, component: /* @__PURE__ */ t(R, { children: c }), errorMessage: s(), label: e.label });
}, ll = O(Et), kt = new Intl.NumberFormat("et-EE", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2
}), De = (e) => kt.format(Number(e)), St = /[^0-9.]/g, xt = /[^0-9.,-]/g, Yt = ({
  disabled: e = !1,
  negativeCommasAllowed: l = !1,
  value: n,
  isPristine: r,
  isRequired: a,
  label: s,
  info: c,
  name: i,
  setValue: d,
  translate: o
}) => {
  const u = "mta.", [f, A] = k.useState(De(n || 0)), M = () => l ? xt : St, b = (v) => v.replace(/\s/g, "").replace(M(), "").replace(",", "."), h = (v) => {
    const y = v.target.value, x = b(y);
    x !== n && (d(x), A(De(y)));
  }, m = () => r ? "" : a && !n ? o && o(`${u}required`) : f === "NaN" ? o && o(`${u}currencyInputNumber`) : "";
  return e ? /* @__PURE__ */ t(q, { component: /* @__PURE__ */ g("span", { className: "disabled_field_value", children: [
    " ",
    f !== "NaN" && f
  ] }), label: s, name: i }) : /* @__PURE__ */ t(q, { component: /* @__PURE__ */ g("div", { children: [
    /* @__PURE__ */ t($, { name: i, onChange: h, type: "tel", value: n }),
    /* @__PURE__ */ t("small", { children: f !== "NaN" && f })
  ] }), errorMessage: m(), info: c, label: s, name: i });
}, al = O(Yt), Dt = /* @__PURE__ */ new Map([["et", "PP.KK.AAAA"]]), Tt = /* @__PURE__ */ new Map([["et", "PP.KK.AAAA TT:mm"]]), Bt = "DD.MM.YYYY", Rt = "dd DD.MM.YYYY", Ft = "DD.MM.YYYY HH:mm", Ot = "DD.MM.YYYY H:mm", Vt = "dd DD.MM.YYYY HH:mm", qt = "dd DD.MM.YYYY H:mm", Pt = "YYYY-MM-DD", Lt = [Bt, Rt, p.ISO_8601], jt = [
  Ft,
  Ot,
  Vt,
  qt,
  p.ISO_8601
], J = (e, l, n) => p(e, n && jt || Lt, l, !0), je = (e, l) => p.isMoment(e) ? e.format(!l && Pt || void 0) : e, Ke = (e, l, n, r) => {
  if (p.isMoment(e))
    return e;
  const a = J(e, n, r);
  return a.isValid() ? a : e;
}, Kt = ({
  className: e = "",
  dateFormat: l = "DD.MM.YYYY",
  isDisabled: n = !1,
  hoursOnly: r = !1,
  includeTime: a = !1,
  locale: s = "et",
  minutesStep: c = 1,
  name: i,
  onChange: d,
  validFromToday: o = !1,
  value: u,
  viewMode: f,
  setValid: A,
  isInsertNullToggled: M = !1
}) => {
  const b = te(null), h = p().subtract(1, "day"), [m, N] = E(() => u ? J(u, s, a) : "");
  U(() => {
    N(!u || u === "" ? "" : J(u, s, a));
  }, [u, s, a]);
  const v = (B, F) => ((F.day() === 0 || F.day() === 6) && (B.className += " rdtWeekend"), /* @__PURE__ */ t("td", { ...B, children: F.date() })), y = (B) => !o || B.isAfter(h), x = () => !m || p.isMoment(m) && m.isValid(), Y = (B) => {
    const F = Ke(B, l, s, a);
    N(F), d?.(F);
  }, P = () => {
    b.current?._openCalendar();
  }, L = x();
  return A?.(L), /* @__PURE__ */ t("div", { className: L ? void 0 : "has-danger", children: /* @__PURE__ */ g("div", { style: { display: "block", position: "relative" }, children: [
    /* @__PURE__ */ t(
      Oe,
      {
        className: `datepicker ${e}`,
        closeOnSelect: !0,
        dateFormat: l,
        inputProps: {
          ...!u || u === "" ? { value: "" } : {},
          disabled: n,
          id: i,
          name: i,
          // @ts-expect-error _closeCalendar is not exposed function on DateTtime
          onFocus: () => b.current?._closeCalendar(),
          placeholder: M ? "Otsi määramata" : a ? Tt.get(s) : Dt.get(s)
        },
        isValidDate: y,
        locale: s,
        onChange: Y,
        ref: b,
        renderDay: v,
        strictParsing: !0,
        timeConstraints: { minutes: { step: r ? 0 : c, min: 0, max: 59 } },
        timeFormat: a,
        utc: !1,
        value: m,
        initialViewMode: f
      }
    ),
    /* @__PURE__ */ t("div", { className: "datepicker-toggle", onClick: n ? void 0 : P })
  ] }) });
}, Ht = (e) => {
  const { includeTime: l = !1 } = e, n = (c) => {
    const i = je(c, l);
    e.setValue?.(i), e.customOnChange && e.customOnChange(i);
  }, r = () => e.required && !e.isValid, a = () => {
    if (e.isFormSubmitted) {
      if (e.showError && e.errorMessage)
        return e.errorMessage;
      if (r() && e.inlineEdit)
        return "Kohustuslik";
    }
  }, s = /* @__PURE__ */ t(
    Kt,
    {
      ...e,
      isDisabled: e.isDisabled,
      name: e.name,
      onChange: n,
      value: e.value || "",
      setValid: e.setValid
    }
  );
  return /* @__PURE__ */ t(
    q,
    {
      component: s,
      errorMessage: a(),
      label: e.label,
      labelCol: e.labelCol,
      labelInfo: e.required ? "Kohustuslik" : void 0,
      labelStyle: e.required && e.isFormSubmitted && !e.isValid ? "label-comment-error" : void 0,
      inline: e.inlineEdit,
      popover: e.popover,
      name: e.name
    }
  );
}, Gt = O(Ht), Ne = (e) => {
  const { dateFormat: l = "DD.MM.YYYY", includeTime: n = !1 } = e;
  return Gt({
    ...e,
    validations: { isDate: !0, ...e.validations },
    validationErrors: {
      isDate: "Sisesta korrektne kuupäev!",
      ...e.validationErrors
    },
    value: e.value && je(Ke(e.value, l, e.locale, n), n),
    ref: e.reference
  });
}, il = ({
  label: e,
  isInsertNull: l,
  isNull: n,
  isDisabled: r,
  isRequired: a,
  isFormSubmitted: s,
  start: c,
  end: i,
  popover: d
}) => {
  const o = te(null), u = te(null), f = c?.reference || o, A = i?.reference || u, [M, b] = E(!1), [h, m] = E(!1), [N, v] = E({
    isStartEmpty: !0,
    isEndEmpty: !0
  }), y = () => {
    m(!h), h ? (f.current.setValue(void 0), A.current.setValue(void 0), b(!1)) : (f.current.setValue(null), A.current.setValue(null), b(!0));
  };
  U(() => {
    n && y();
  }, [n]), r && h && y();
  const x = /* @__PURE__ */ g(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "space-between"
      },
      children: [
        /* @__PURE__ */ t(
          "span",
          {
            style: {
              flexGrow: 1
            },
            children: /* @__PURE__ */ t(
              Ne,
              {
                ...c,
                inlineEdit: !0,
                isInsertNull: l,
                required: (a || c?.isRequired) && N.isEndEmpty,
                isInsertNullToggled: h,
                reference: f,
                isDisabled: M || r,
                customOnChange: (Y) => {
                  v({
                    isStartEmpty: !Y,
                    isEndEmpty: N.isEndEmpty
                  });
                },
                labelCol: { sm: 0, md: 0, lg: 0 },
                className: s && c?.isRequired && N.isStartEmpty && " has-danger" || void 0
              }
            )
          }
        ),
        /* @__PURE__ */ t("span", { style: { fontSize: "20px", margin: "0 15px" }, children: "-" }),
        /* @__PURE__ */ t(
          "span",
          {
            style: {
              flexGrow: 1
            },
            children: /* @__PURE__ */ t(
              Ne,
              {
                ...i,
                inlineEdit: !0,
                isInsertNull: l,
                required: (a || i?.isRequired) && N.isStartEmpty,
                isInsertNullToggled: h,
                reference: A,
                isDisabled: M || r,
                customOnChange: (Y) => {
                  v({
                    isStartEmpty: N.isStartEmpty,
                    isEndEmpty: !Y
                  });
                },
                labelCol: { sm: 0, md: 0, lg: 0 },
                className: s && i?.isRequired && N.isEndEmpty && " has-danger" || void 0
              }
            )
          }
        ),
        l && /* @__PURE__ */ t(
          Le,
          {
            name: e,
            disabled: r,
            className: h ? "btn-dark" : "btn-light",
            secondary: !0,
            onChange: y,
            checked: h,
            style: { marginLeft: "20px" },
            popover: {
              content: /* @__PURE__ */ t("ul", { children: "Päri määramata väärtuseid" }),
              placement: "right",
              target: "proceedingExplanation"
            }
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ t(
    q,
    {
      component: x,
      label: e,
      labelInfo: (a || c?.isRequired || i?.isRequired) && "Kohustuslik",
      labelStyle: s && (a && N.isStartEmpty && N.isEndEmpty || c?.isRequired && N.isStartEmpty || i?.isRequired && N.isEndEmpty) ? "label-comment-error" : void 0,
      popover: d,
      isOnlyOneFieldRequired: !a && !!c?.isRequired != !!i?.isRequired
    }
  );
}, sl = ({ children: e, columnWidth: l = 10 }) => k.Children.toArray(e).length > 2 ? /* @__PURE__ */ t("div", { children: "This element is configured to take only 1 or 2 children" }) : /* @__PURE__ */ t(R, { children: k.Children.map(e, (n, r) => {
  const a = k.isValidElement(n) ? k.cloneElement(n, { label: n.props.label }) : n;
  return /* @__PURE__ */ t(w, { xl: r == 0 ? l : 20 - l, md: l * 2, sm: 20, xs: 20, children: a }, r);
}) }), Ut = (e) => {
  const { setValue: l, customOnChange: n } = e, [r, a] = E(!1), [s, c] = E(!1), i = (A) => {
    const M = A.currentTarget.value;
    l(M), n && n(M);
  }, d = X(() => {
    c((A) => !A), s ? (l(void 0), a(!1)) : (l(null), a(!0));
  }, [s, l]), o = X(() => e.required && !e.isValid, [e.isValid, e.required]), u = X(() => {
    if (e.isFormSubmitted) {
      if (e.showError && e.errorMessage)
        return e.errorMessage;
      if (o() && e.inlineEdit)
        return "Kohustuslik";
    }
  }, [e.errorMessage, e.inlineEdit, e.isFormSubmitted, e.showError, o]), f = /* @__PURE__ */ g("span", { style: { display: "flex" }, children: [
    /* @__PURE__ */ t(
      $,
      {
        className: e.labelAfter ? "input-short" : " " + e.className,
        disabled: r || e.disabled,
        id: e.name,
        maxLength: e.maxLength,
        name: e.name,
        onChange: i,
        onInput: i,
        ...s && {
          placeholder: "Otsi määramata"
        },
        ...e.onClickSelectField && {
          onClick: (A) => {
            const M = A.currentTarget;
            M.value === "0" && M.select();
          }
        },
        value: e.value || ""
      }
    ),
    e.isInsertNull && /* @__PURE__ */ t("span", { style: { marginLeft: "1rem" }, children: /* @__PURE__ */ t(
      Ce,
      {
        label: "Määramata",
        className: s ? "btn-dark" : "btn-light",
        secondary: !0,
        onClick: d
      }
    ) })
  ] });
  return e.isVertical ? /* @__PURE__ */ t(
    ae,
    {
      ...e,
      component: f,
      errorMessage: e.isFormSubmitted && e.showError && e.errorMessage ? e.errorMessage : void 0,
      label: e.label,
      labelAfter: e.labelAfter,
      labelCol: e.labelCol,
      name: e.name,
      labelInfo: e.required && "Kohustuslik",
      labelStyle: e.isFormSubmitted && o() ? "label-comment-error-vertical" : void 0,
      inline: e.inlineEdit
    }
  ) : /* @__PURE__ */ t(
    q,
    {
      component: f,
      errorMessage: u(),
      label: e.label,
      labelAfter: e.labelAfter,
      labelCol: e.labelCol,
      name: e.name,
      labelInfo: e.required ? "Kohustuslik" : void 0,
      labelStyle: e.isFormSubmitted && o() ? "label-comment-error" : void 0,
      inline: e.inlineEdit,
      popover: e.popover
    }
  );
}, Qt = O(Ut), zt = (e) => Qt({
  ...e,
  ref: e.reference
}), Jt = ({ unWrapped: e = !1, rows: l = 4, ...n }) => {
  const [r, a] = E(
    n.maxLength ? Math.max(0, n.maxLength - (n.value?.length || 0)) : 0
  ), s = (u) => {
    const f = u.currentTarget.value;
    n.setValue(f), n.maxLength && a(n.maxLength - f.length);
  }, c = () => n.required && !n.isValid, i = () => {
    if (n.showError && n.errorMessage)
      return n.errorMessage;
    if (n.isFormSubmitted && c() && n.inlineEdit)
      return "Kohustuslik";
  }, d = /* @__PURE__ */ g("div", { children: [
    n.maxLength ? /* @__PURE__ */ t("span", { className: e ? "unwrapped-char-counter" : "textarea-char-counter", children: r }) : null,
    /* @__PURE__ */ t(
      $,
      {
        className: "hidden-print",
        id: n.name,
        name: n.name,
        onChange: s,
        readOnly: n.disabled,
        rows: l,
        style: { resize: "none" },
        type: "textarea",
        value: n.value
      }
    ),
    /* @__PURE__ */ t("div", { className: `print-textarea show-print${n.disabled ? " disabled" : ""}`, children: n.value })
  ] });
  if (e)
    return d;
  const o = {
    ...n,
    component: d,
    errorMessage: i(),
    info: n.info,
    label: n.label,
    labelInfo: n.required ? "Kohustuslik" : void 0,
    name: n.name,
    labelStyle: n.required && n.isFormSubmitted && !n.isValid ? "label-comment-error" : void 0
  };
  return n.isVertical ? /* @__PURE__ */ t(ae, { ...o }) : /* @__PURE__ */ t(q, { ...o });
}, rl = O(Jt), pt = "HH:mm", Zt = (e) => p.isMoment(e) ? e.format(pt) : e, Xt = ({
  name: e,
  value: l = "",
  onChange: n = () => {
  },
  hoursOnly: r = !1,
  locale: a = "et",
  minutesStep: s = 1,
  placeholder: c = "Vali kellaaeg"
}) => {
  const [i, d] = E(l), o = te(null);
  return U(() => {
    l !== i && d(l);
  }, [l]), /* @__PURE__ */ g("div", { children: [
    /* @__PURE__ */ t(
      Oe,
      {
        className: "timepicker",
        dateFormat: !1,
        inputProps: {
          name: e,
          // @ts-expect-error _closeCalendar is not exposed function on DateTtime
          onFocus: () => o.current?._closeCalendar(),
          placeholder: c
        },
        locale: a,
        onChange: (A) => {
          d(A), n(Zt(A));
        },
        ref: o,
        timeConstraints: { minutes: { step: r ? 0 : s, min: 0, max: 59 } },
        value: i
      }
    ),
    /* @__PURE__ */ t("div", { className: "timepicker-toggle", onClick: () => {
      o.current?._openCalendar();
    } })
  ] });
}, Wt = "mta.", $t = (e) => {
  const l = (a) => {
    e.setValue(a);
  }, n = () => e.isPristine ? "" : e.isRequired && !e.value ? e.translate && e.translate(`${Wt}required`) : "", r = /* @__PURE__ */ t(
    Xt,
    {
      ...e,
      hoursOnly: e.hoursOnly,
      name: e.name,
      onChange: l,
      placeholder: e.placeholder,
      value: e.value
    }
  );
  return /* @__PURE__ */ t(q, { component: r, errorMessage: n(), label: e.label });
}, cl = O($t), _t = ({ children: e, directParent: l, name: n, onChange: r, value: a }) => {
  const [s, c] = E(a), i = (o) => {
    c(o), r(o);
  }, d = (o) => {
    if (!k.isValidElement(o)) return o;
    if (l) {
      const u = { checked: s === o.props.value, name: n, toggle: i };
      return k.cloneElement(o, u);
    } else {
      const u = o.props.children;
      if (!k.isValidElement(u)) return o;
      const f = { checked: s === u.props.value, name: n, toggle: i };
      return k.cloneElement(o, {}, k.cloneElement(u, f));
    }
  };
  return /* @__PURE__ */ t(T, { children: k.Children.map(e, d) });
}, en = ({
  checked: e = !1,
  disabled: l = !1,
  id: n,
  info: r,
  inline: a = !1,
  label: s,
  name: c,
  toggle: i,
  value: d,
  ...o
}) => /* @__PURE__ */ g(Ie, { ...o, className: "custom-control custom-radio", style: a ? { display: "inline" } : {}, children: [
  /* @__PURE__ */ t(
    $,
    {
      checked: e,
      className: "custom-control-input",
      disabled: l,
      name: c,
      onChange: () => i?.(d),
      type: "radio",
      value: d
    }
  ),
  /* @__PURE__ */ t("span", { className: "custom-control-indicator" }),
  s && /* @__PURE__ */ t("span", { className: "custom-control-description", children: s }),
  r && /* @__PURE__ */ g(T, { children: [
    /* @__PURE__ */ t(
      "a",
      {
        href: "javascript:void(0);",
        className: "icon-info light-icon small-icon pl-1",
        id: `tooltip-${n || d}`
      }
    ),
    /* @__PURE__ */ t(H, { content: r.content, target: `tooltip-${n || d}`, title: r.title })
  ] })
] }), tn = ({ directParent: e = !1, withoutWrapper: l = !0, ...n }) => {
  const r = (c) => {
    n.setValue(c), n.customOnChange?.(c);
  }, a = () => {
    const c = "mta.";
    return n.isPristine ? "" : n.isRequired && !n.value ? n.translate && n.translate(`${c}required`) : "";
  }, s = /* @__PURE__ */ t(
    _t,
    {
      disabled: n.disabled,
      directParent: e,
      info: n.info,
      name: n.name,
      onChange: r,
      value: n.value,
      children: n.children
    }
  );
  return l ? s : /* @__PURE__ */ t(
    Ae,
    {
      component: s,
      errorMessage: a(),
      label: n.label,
      labelCol: n.labelCol,
      name: n.name
    }
  );
}, nn = O(tn), ol = ({
  children: e,
  ignorePristine: l,
  ignoreEmpty: n,
  nonFormatFields: r,
  getInitialModel: a,
  reset: s,
  ...c
}) => {
  const i = te(null), d = () => {
    i.current?.reset();
  };
  U(() => {
    s && d();
  }, [s]), U(() => {
    a && i.current && a(i.current.getModel());
  }, [a]);
  const o = (b) => {
    if (!i.current?.inputs) return;
    i.current.inputs.filter(
      (m) => m.isPristine() || m.getValue() === m.props.value || m.getValue() === "" && m.props.value === void 0
    ).map((m) => m.props.name).forEach((m) => {
      delete b[m];
    });
  }, u = (b) => {
    if (!i.current?.inputs) return;
    i.current.inputs.filter((m) => m.getValue() === "" && m.props.value === void 0).map((m) => m.props.name).forEach((m) => {
      delete b[m];
    });
  }, f = (b) => {
    const h = /^\d*,\d*$/;
    Object.keys(b).forEach((m) => {
      const N = r ? !r.includes(m) : !0;
      h.test(b[m]) && N && (b[m] = b[m].replace(",", "."));
    });
  }, A = (b) => {
    Object.keys(b).forEach((h) => {
      (typeof b[h] == "string" || b[h] instanceof String) && (b[h] = b[h].trim());
    });
  }, M = () => (b) => (l && o(b), n && u(b), A(b), f(b), b);
  return it(() => {
    j("isNotEmptyValue", (b, h) => !!h), j("doesEitherExist", (b, h, m) => !!(h || b[m])), j("doesBothExist", (b, h, m) => !!(h && b[m] || !h && !b[m])), j("isPositiveInt", (b, h) => !h || Number.isInteger(Number(h)) && Number(h) > 0), j("isCreatableSelectTooLong", (b, h, m) => h ? h.reduce((N, v) => N + v.value, "").length <= m : !0), j("isDate", (b, h, m = "et") => !h || J(h, m, !1).isValid()), j("isBefore", (b, h, m, N = "et") => !h || !b[m] || J(h, N, !1).isSameOrBefore(J(b[m], N, !1))), j("isAfter", (b, h, m, N = "et") => !h || !b[m] || J(h, N, !1).isSameOrAfter(J(b[m], N, !1))), j("isFuture", (b, h, m = "et") => !h || J(h, m, !1).isAfter(p().startOf("day"))), j("isNotPast", (b, h, m = "et") => !h || !J(h, m, !1).isBefore(p().startOf("day"))), j("isPosIntGreaterThanArg", (b, h, m) => !h || Number.isInteger(Number(h)) && Number(h) > 0 && Number(h) > Number(m)), j("isPosIntLessThanOtherField", (b, h, m) => !h || !b[m] || Number.isInteger(Number(h)) && Number(h) > 0 && Number(h) < Number(b[m]));
  }, []), l && n ? /* @__PURE__ */ t(T, { children: "Only one of ignorePristine or ignoreEmpty can be used" }) : /* @__PURE__ */ t(Ve, { ...c, autoComplete: "off", ref: i, mapping: M(), children: e });
}, ln = (e) => {
  const { isClearable: l = !0, isCreatable: n = !1, isMulti: r = !1, placeholder: a = "", value: s = null } = e, c = (m) => {
    const N = r && m?.length === 0 ? null : m;
    e.setValue?.(N), e.onChange?.(N);
  }, i = (m) => {
    e.onBlur?.(m);
  }, d = () => e.required && !e.isValid, o = 23, u = 30, f = e.inlineEdit || e.tableEdit, A = {
    control: (m) => ({
      ...m,
      borderRadius: "5px",
      border: `2px solid ${e.isFormSubmitted && e.showError && e.errorMessage ? "#ff7373" : "#dbdfe2"}`,
      minHeight: f ? "initial" : void 0,
      ...e.customStyle || {}
    }),
    container: (m) => ({
      ...m,
      position: e.tableEdit ? "initial" : m.position,
      width: "100%"
    }),
    menu: (m) => e.tableEdit ? {
      ...m,
      top: "initial",
      width: "initial"
    } : {
      ...m
    },
    valueContainer: (m) => ({
      ...m,
      minHeight: `${f ? o - 2 : u - 2}px`,
      padding: "0 8px"
    }),
    singleValue: (m) => ({
      ...m
    }),
    input: (m) => ({
      ...m,
      margin: "0px",
      padding: "0px"
    }),
    clearIndicator: (m) => ({
      ...m,
      padding: `${((f ? o : u) - 22) / 2}px`
    }),
    dropdownIndicator: (m) => ({
      ...m,
      padding: `${((f ? o : u) - 22) / 2}px`
    }),
    indicatorSeparator: (m) => ({
      ...m,
      margin: f ? "4px 0" : m.margin
    }),
    multiValueRemove: (m) => ({
      ...m,
      ...!l && {
        display: "none"
      }
    }),
    multiValue: (m) => ({
      ...m,
      paddingRight: l ? m.paddingRight : "6px"
    })
  }, M = () => {
    if ((e.isFormSubmitted || s) && e.showError && e.errorMessage)
      return e.errorMessage;
    if (d() && e.inlineEdit)
      return "Kohustuslik";
  }, h = {
    component: n ? /* @__PURE__ */ t(
      We,
      {
        isClearable: l,
        isDisabled: e.disabled,
        isMulti: r,
        name: e.name,
        onBlur: i,
        onChange: c,
        onFocus: e.onFocus,
        onInputChange: e.onInputChange,
        options: e.options,
        placeholder: a,
        styles: A,
        value: s,
        defaultValue: e.defaultValue
      }
    ) : /* @__PURE__ */ t("span", { style: { display: "flex" }, children: /* @__PURE__ */ t(
      $e,
      {
        isClearable: l,
        isDisabled: e.disabled,
        isMulti: r,
        name: e.name,
        "aria-label": e.name,
        onBlur: i,
        onChange: c,
        onFocus: e.onFocus,
        onInputChange: e.onInputChange,
        options: e.options,
        placeholder: a,
        styles: A,
        value: s,
        defaultValue: e.defaultValue,
        inputId: e.name
      }
    ) }),
    errorMessage: M(),
    isErrorScrollDisabled: e.isErrorScrollDisabled,
    label: e.label,
    labelCol: e.labelCol,
    name: e.name,
    popover: e.popover,
    labelInfo: e.required ? "Kohustuslik" : void 0,
    labelStyle: e.required && e.isFormSubmitted && !e.isValid ? "label-comment-error" : void 0,
    inline: f
  };
  return e.isVertical ? /* @__PURE__ */ t(ae, { ...h }) : /* @__PURE__ */ t(q, { ...h });
}, an = O(ln), He = (e) => {
  const { reference: l, ...n } = e;
  return an({
    ...n,
    ref: l
  });
}, sn = (e, l) => {
  const {
    isClearable: n = !0,
    isMulti: r = !1,
    placeholder: a = "",
    value: s = null,
    minInputLength: c = 1,
    minNumericInputLength: i = 1,
    minLengthErrorMessage: d = "",
    showArrow: o = !1,
    resetInput: u = !1,
    disableCache: f = !1
  } = e, [A, M] = E(""), b = 23, h = 30, m = {
    control: (I) => ({
      ...I,
      borderRadius: "5px",
      border: `2px solid ${e.isFormSubmitted && e.showError && e.errorMessage ? "#ff7373" : "#dbdfe2"}`,
      ...e.inlineEdit && {
        minHeight: "initial"
      },
      ...e.customStyle
    }),
    container: (I) => ({
      ...I,
      width: "100%",
      height: e.inlineEdit ? "inherit" : "30px"
    }),
    valueContainer: (I) => ({
      ...I,
      minHeight: `${e.inlineEdit ? b - 2 : h - 2}px`,
      padding: "0 8px"
    }),
    singleValue: (I) => ({
      ...I,
      ...e.inlineEdit && {
        position: "initial",
        transform: "initial"
      }
    }),
    input: (I) => ({
      ...I,
      margin: "0px",
      padding: "0px"
    }),
    clearIndicator: (I) => ({
      ...I,
      padding: `${((e.inlineEdit ? b : h) - 22) / 2}px`
    }),
    dropdownIndicator: (I) => ({
      ...I,
      padding: `${((e.inlineEdit ? b : h) - 22) / 2}px`
    }),
    indicatorSeparator: (I) => ({
      ...I,
      ...e.inlineEdit && {
        margin: "4px 0"
      }
    }),
    multiValueRemove: (I) => ({
      ...I,
      ...!n && {
        display: "none"
      }
    }),
    multiValue: (I) => ({
      ...I,
      ...!n && {
        paddingRight: "6px"
      }
    })
  }, N = (I) => {
    const V = r && I?.length === 0 ? null : I;
    e.setValue(V), e.onChange?.(V);
  }, v = (I) => {
    e.onBlur && e.onBlur(I);
  }, y = (I, V) => {
    u ? V.action !== "input-blur" && V.action !== "menu-close" ? M(I) : M("") : V.action !== "input-blur" && V.action !== "menu-close" && M(I);
  }, x = (I) => /^\d+$/.test(I), Y = (I) => x(I) ? I.length >= (i || c) : I.length >= c, P = () => !!(e.required && !e.isValid), L = () => {
    if (A && !Y(A))
      return d;
    if ((e.isFormSubmitted || s) && e.showError)
      return e.errorMessage;
    if (P() && e.inlineEdit)
      return "Kohustuslik";
  }, B = /* @__PURE__ */ g("div", { style: { display: "flex", justifyContent: "space-between" }, children: [
    /* @__PURE__ */ t(
      Fe,
      {
        ...e,
        inputValue: A,
        loadingMessage: () => Y(A) ? "Laeb..." : null,
        noOptionsMessage: () => Y(A) ? "Valikud puuduvad" : null,
        cacheOptions: !f,
        loadOptions: e.loadOptions,
        onInputChange: y,
        openMenuOnClick: !1,
        components: o ? {} : {
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null
        },
        isClearable: n,
        onBlur: v,
        onChange: N,
        placeholder: a,
        value: s,
        styles: m,
        isMulti: r,
        ref: l,
        defaultOptions: e.defaultOptions,
        inputId: e.name
      }
    ),
    e.button && /* @__PURE__ */ g(T, { children: [
      /* @__PURE__ */ t(
        ut,
        {
          onClick: e.button.onClick,
          iconName: "icon-add-square",
          isSmall: e.inlineEdit,
          style: { marginLeft: "10px" }
        }
      ),
      e.button.popover && /* @__PURE__ */ g("div", { children: [
        /* @__PURE__ */ t(
          "a",
          {
            href: "javascript:void(0);",
            className: `icon-info light-icon small-icon${e.inlineEdit ? " small-icon" : ""}`,
            id: e.button.popover.target
          }
        ),
        /* @__PURE__ */ t(H, { ...e.button.popover })
      ] })
    ] })
  ] }), F = L(), Q = {
    component: B,
    errorMessage: F,
    isErrorScrollDisabledShow: !0,
    label: e.label,
    labelCol: e.labelCol,
    name: e.name,
    popover: e.popover,
    labelInfo: e.required ? "Kohustuslik" : void 0,
    labelStyle: e.required && e.isFormSubmitted && !e.isValid ? "label-comment-error" : void 0,
    inline: e.inlineEdit
  };
  return e.isVertical ? /* @__PURE__ */ t(ae, { ...Q }) : /* @__PURE__ */ t(q, { ...Q });
}, rn = k.forwardRef(sn), cn = (e) => /* @__PURE__ */ t(rn, { ...e }), on = O(cn), dl = (e) => on({
  ...e,
  ref: e.reference
}), dn = ({ children: e, label: l, labelCol: n, ...r }) => {
  const a = Math.round(20 / k.Children.toArray(e).length), s = k.Children.map(e, (c, i) => {
    if (!k.isValidElement(c))
      return c;
    const d = k.cloneElement(c, {
      label: "",
      labelCol: { lg: 0 }
    }), o = c.props.colSize || {};
    return /* @__PURE__ */ t(w, { lg: o.lg || a, md: o.md, sm: o.sm, children: d }, i);
  });
  return /* @__PURE__ */ t(q, { ...r, component: /* @__PURE__ */ t(R, { children: s }), label: l, labelCol: n });
}, ml = O(dn);
class mn extends /*Select*/
k.Component {
  constructor(l) {
    super(l), this.renderOuter = this._renderOuter;
  }
  componentDidMount() {
    this.dropdownFieldNode = st.findDOMNode(this);
  }
  getTopPosition(l) {
    let n = l.getBoundingClientRect().top + window.pageYOffset - l.clientTop;
    return Math.round(n + l.clientHeight);
  }
  _renderOuter() {
    const l = super.renderOuter.apply(this, arguments);
    return /* @__PURE__ */ t(_e, { attachment: "top left", options: {
      targetAttachment: "bottom left",
      constraints: [
        {
          to: "window",
          attachment: "together"
        }
      ]
    }, target: this.dropdownFieldNode, children: k.cloneElement(l, {
      style: { top: this.getTopPosition(this.wrapper), width: this.wrapper.offsetWidth - 1 }
    }) });
  }
}
const un = "mta.", hn = ({
  valueAsEntity: e = !0,
  labelKey: l = "text",
  valueKey: n = "code",
  labelCol: r = { sm: 20, md: 6, lg: 6 },
  locale: a = "et",
  placeholder: s = "",
  translate: c,
  ...i
}) => {
  const d = () => i.isPristine ? "" : i.showRequired ? c && c(`${un}required`) : "", o = (h) => {
    i.setValue(h);
  }, u = () => {
    i.onBlur && i.onBlur();
  }, f = {
    control: (h) => ({
      ...h,
      borderRadius: "5px",
      border: `2px solid ${i.isFormSubmitted && i.showError && i.errorMessage ? "#ff7373" : "#dbdfe2"}`,
      ...i.customStyle
    }),
    container: (h) => ({
      ...h,
      position: "initial"
    }),
    menu: (h) => ({
      ...h,
      top: "initial",
      width: "initial"
    })
  }, A = i.value?.texts?.[a], M = A && { code: i.value?.code, text: A } || i.value || "", b = /* @__PURE__ */ t(
    mn,
    {
      disabled: i.disabled,
      getOptionLabel: (h) => h[l],
      getOptionValue: (h) => h[n],
      multi: !1,
      name,
      onBlur: u,
      onChange: o,
      onFocus: i.onFocus,
      options: i.options,
      placeholder: s,
      simpleValue: !e,
      styles: f,
      value: M,
      valueKey: n
    }
  );
  return /* @__PURE__ */ t(
    q,
    {
      component: b,
      errorMessage: i.customErrorMessage ? i.customErrorMessage() : d(),
      isErrorScrollDisabled: i.isErrorScrollDisabled,
      label: i.label,
      labelCol: r,
      name: i.name
    }
  );
}, ul = O(hn), gn = ({
  checked: e = !1,
  id: l,
  label: n = "Sees",
  name: r,
  onChange: a,
  disabled: s
}) => {
  const [c, i] = E(e), d = k.useRef(`checkbox-${Date.now()}`), o = X(() => {
    const u = !c;
    i(u), a?.(u);
  }, [c, a]);
  return /* @__PURE__ */ g(Ie, { className: "switch", children: [
    /* @__PURE__ */ t(
      $,
      {
        checked: c,
        disabled: s,
        id: l || d.current,
        name: r,
        onChange: o,
        type: "checkbox"
      }
    ),
    /* @__PURE__ */ t("div", { className: "slider" }),
    n && /* @__PURE__ */ t("span", { className: "switch-text", children: n })
  ] });
}, fn = (e) => {
  const { setValue: l, labelArea: n, labelCol: r, name: a, update: s, value: c } = e, d = /* @__PURE__ */ t(gn, { ...e, checked: c, onChange: (o) => {
    l(o), s?.(a, o);
  }, value: c });
  return /* @__PURE__ */ t(Ae, { component: d, labelArea: n, labelCol: r, name: a });
}, hl = O(fn), gl = ({ radioValues: e, topicLabels: l, defaultValue: n, translate: r }) => {
  const a = e.length, s = 20, c = 3, i = s - a * c;
  return /* @__PURE__ */ g("div", { className: "multiple-choice-form", children: [
    /* @__PURE__ */ g(R, { className: "multiple-choice-header", children: [
      /* @__PURE__ */ t(w, { xs: i }),
      e.map((d) => /* @__PURE__ */ t(T, { children: /* @__PURE__ */ t(w, { xs: c, children: d }) }))
    ] }),
    l.map((d) => /* @__PURE__ */ g(T, { children: [
      /* @__PURE__ */ t(R, { className: "multiple-choice-topic", children: /* @__PURE__ */ t(w, { children: d.topic }) }),
      d.labels.map((o) => /* @__PURE__ */ g(R, { className: "multiple-choice-label", children: [
        /* @__PURE__ */ t(w, { xs: i, children: o }),
        /* @__PURE__ */ t(nn, { name: o, value: n, translate: r, children: e.map((u) => /* @__PURE__ */ t(w, { xs: c, children: /* @__PURE__ */ t(en, { value: u }) }, u)) })
      ] }, o))
    ] }))
  ] });
}, bn = (e) => {
  const {
    className: l = "",
    customOnChange: n,
    disabled: r,
    value: a,
    isVertical: s,
    label: c,
    labelAfter: i,
    labelCol: d,
    inlineEdit: o,
    maxLength: u,
    name: f,
    setValue: A,
    buttonText: M,
    buttonOnCall: b,
    isFormSubmitted: h,
    errorMessage: m,
    popover: N,
    required: v,
    isInsertNull: y,
    isValid: x,
    showError: Y
  } = e, [P, L] = E(!1), [B, F] = E(!1), Q = (C) => {
    const S = C.currentTarget.value;
    A(S), n && n(S);
  }, I = () => {
    F((C) => !C), B ? (A(void 0), L(!1)) : (A(null), L(!0));
  }, V = () => v && !x, ie = () => {
    if (h) {
      if (Y && m)
        return m;
      if (V() && o)
        return "Kohustuslik";
    }
  }, Z = /* @__PURE__ */ g("span", { style: { display: "flex" }, children: [
    /* @__PURE__ */ t("span", { style: { marginRight: "1rem" }, children: M && /* @__PURE__ */ t(G, { label: M, onClick: b }) }),
    /* @__PURE__ */ t(
      $,
      {
        className: (i ? "input-short" : "") + " " + l,
        disabled: P || r,
        id: f,
        maxLength: u,
        name: f,
        onChange: Q,
        onInput: Q,
        ...B && { placeholder: "Otsi määramata" },
        value: a || ""
      }
    ),
    y && /* @__PURE__ */ t("span", { style: { marginLeft: "1rem" }, children: /* @__PURE__ */ t(
      Ce,
      {
        label: "Määramata",
        className: B ? "btn-dark" : "btn-light",
        secondary: !0,
        onClick: I
      }
    ) })
  ] });
  return s ? /* @__PURE__ */ t(
    ae,
    {
      ...e,
      component: Z,
      errorMessage: h && e.showError && m ? m : void 0,
      label: c,
      labelAfter: i,
      labelCol: d,
      name: f,
      labelInfo: v ? "Kohustuslik" : void 0,
      labelStyle: h && V() ? "label-comment-error-vertical" : void 0,
      inline: o
    }
  ) : /* @__PURE__ */ t(
    q,
    {
      component: Z,
      errorMessage: ie(),
      label: c,
      labelAfter: i,
      labelCol: d,
      name: f,
      labelInfo: v ? "Kohustuslik" : void 0,
      labelStyle: h && V() ? "label-comment-error" : void 0,
      inline: o,
      popover: N
    }
  );
}, An = O(bn), fl = (e) => An({
  ...e,
  ref: e.reference
}), Mn = "mta.", vn = { textDecoration: "underline", cursor: "pointer", verticalAlign: "middle" }, Nn = {
  text: zt,
  date: Ne,
  select: He
}, In = (e) => "form-" + Date.now() + "-" + e, yn = ({ filterColumns: e = [], locale: l, onFilter: n, useI18n: r }) => {
  const [a, s] = E({}), c = te({}), i = (u, f) => {
    const A = {
      ...a,
      [u]: f
    };
    s(A), n?.(A);
  }, d = () => {
    Object.values(c.current).forEach((u) => {
      u?.reset();
    }), s({}), n?.({});
  }, o = {
    minWidth: `${1200 / e.length - 50}px`
  };
  return /* @__PURE__ */ t("tr", { children: e.map((u, f) => {
    if (f === e.length - 1)
      return /* @__PURE__ */ t("td", { style: o, children: /* @__PURE__ */ g("a", { onClick: d, style: vn, children: [
        "translate && translate(`$",
        Mn,
        "filterReset`)"
      ] }) }, f);
    if (!u)
      return /* @__PURE__ */ t("td", { style: o }, f);
    const A = Nn[u.type];
    return /* @__PURE__ */ t("td", { style: o, children: /* @__PURE__ */ t(
      Ve,
      {
        ref: (M) => {
          M && (c.current[In(u.name)] = M);
        },
        children: /* @__PURE__ */ t(
          A,
          {
            customOnChange: (M) => i(u.name, M),
            locale: l,
            name: u.name,
            useI18n: r
          }
        )
      }
    ) }, f);
  }) });
}, Cn = () => /* @__PURE__ */ g("div", { className: "sort-arrows", children: [
  /* @__PURE__ */ t("div", { className: "sort-ascending" }),
  /* @__PURE__ */ t("div", { className: "sort-descending" })
] }), wn = ({
  header: e,
  tableId: l,
  headerIndex: n,
  onSorting: r,
  direction: a,
  sortableColumnName: s,
  withMinWidth: c,
  withMaxWidth: i
}) => {
  const d = () => a === "ASC" ? "DESC" : "ASC", o = ge(l, e, n), u = () => {
    s && r?.(s, d());
  }, f = s ? `sorted-${a === "ASC" ? "ascending" : a === "DESC" ? "descending" : ""}` : D({
    extensive: c && !i,
    maxWidthTableHeader: i && !c
  });
  return /* @__PURE__ */ t("th", { id: o, className: f || void 0, children: s ? /* @__PURE__ */ g("a", { onClick: u, children: [
    /* @__PURE__ */ t(Cn, {}),
    e
  ] }) : e });
}, fe = ({ loading: e, wrapperStyle: l, ...n }) => /* @__PURE__ */ t("div", { className: "table-responsive table-hover", style: l, children: e ? /* @__PURE__ */ t("div", { className: "col-xs-20", style: { height: "25px", position: "relative" }, children: /* @__PURE__ */ t("div", { style: { position: "absolute", right: 0, margin: "0 50%" }, children: /* @__PURE__ */ t(ne, { delay: 200, size: 20 }) }) }) : /* @__PURE__ */ t("table", { className: "table", ...n }) }), bl = (e) => {
  const {
    collapsable: l = !0,
    hasNewRow: n = !1,
    locale: r = "et",
    newRowButtonOnTop: a = !1,
    noRowsMessage: s = "Andmed puuduvad",
    tableContainsButtons: c = !1
  } = e, [i, d] = E(!1), o = () => {
    d((A) => !A);
  }, u = e.content && e.content.length === 0, f = be(e.id);
  return /* @__PURE__ */ g(
    Pe,
    {
      collapsable: l,
      withCollapseIcon: l,
      collapsed: l && !e.newRowButton && !e.onEditSection && (!e.content || e.content.length === 0),
      filterable: e.filterable,
      form: e.form,
      hideTitle: !e.title,
      noMarginTop: e.noMarginTop,
      onToggleFilter: o,
      title: e.title,
      trackState: e.trackSectionState,
      withSettings: e.settingsEnabled,
      onEdit: e.onEditSection,
      isLocked: e.isLocked,
      children: [
        e.additionalHeader,
        a && e.newRowButton,
        e.loading ? /* @__PURE__ */ t("div", { className: "col-xs-20", style: { height: "25px", position: "relative" }, children: /* @__PURE__ */ t("div", { style: { position: "absolute", right: 0, margin: "0 50%" }, children: /* @__PURE__ */ t(ne, { delay: 200, size: 20 }) }) }) : u ? /* @__PURE__ */ t("div", { className: "section-content-placeholder", children: /* @__PURE__ */ t(bt, { children: s }) }) : /* @__PURE__ */ g(T, { children: [
          /* @__PURE__ */ g(fe, { id: f, loading: !1, wrapperStyle: e.wrapperStyle, children: [
            /* @__PURE__ */ g("thead", { children: [
              e.filterable && i && /* @__PURE__ */ t(yn, { filterColumns: e.filterColumns, onFilter: e.onFilter, translate: e.translate }),
              (!u || n) && /* @__PURE__ */ g("tr", { children: [
                e.headers.map((A, M) => {
                  const b = e.headersWithMinWidth?.includes(A) ?? !1, h = e.headerWithMaxWidth?.includes(A) ?? !1;
                  return /* @__PURE__ */ t(
                    wn,
                    {
                      tableId: f,
                      header: A,
                      headerIndex: M,
                      onSorting: e.onSorting,
                      direction: e.sortableColumns?.[M]?.direction,
                      sortableColumnName: e.sortableColumns?.[M]?.sortBy,
                      withMinWidth: b,
                      withMaxWidth: h
                    },
                    M
                  );
                }),
                e.editable && /* @__PURE__ */ t("th", { id: ge(f, "headerEditable"), children: e.customEditRowName })
              ] })
            ] }),
            e.content && /* @__PURE__ */ t("tbody", { children: e.content.map((A, M) => /* @__PURE__ */ t(
              It,
              {
                tableId: f,
                headers: e.headers,
                rowNr: M,
                customEditRowComponent: e.customEditRowComponent,
                data: A,
                editable: e.editable,
                rowId: e.rowIds?.[M] ?? M,
                rowId2: e.rowIds2?.[M] ?? M,
                locale: r,
                onDelete: e.onDeleteRow,
                onEdit: e.onEditRow,
                tableContainsButtons: c,
                subHeaders: e.subTables?.headers,
                subContent: e.subTables?.contents?.[M],
                subTogglers: e.subTables?.togglers,
                subEditable: e.subTables?.editable,
                subCustomEditRowComponent: e.subTables?.customEditRowComponent,
                subRowIds: e.subTables?.rowIds?.[M],
                wrapBigColumns: e.wrapBigColumns,
                isCustomColorRow: e.rowIds && e.customColorRowIds?.includes(Number(e.rowIds[M])),
                openByDefault: e.subTables?.openByDefault
              },
              M
            )) })
          ] }),
          e.paginator && /* @__PURE__ */ t(Nt, { onPagination: e.onPagination, paginator: e.paginator })
        ] }),
        !a && /* @__PURE__ */ t("div", { className: "text-md-right new-row-button", children: e.newRowButton }),
        e.children
      ]
    }
  );
}, En = {
  width: "100%",
  border: "none"
}, kn = ({
  immediateUpload: e,
  maxSizeBytes: l = 52428800,
  // 50MB
  onUpload: n,
  uploadInProgress: r,
  uploadedFiles: a,
  validExtension: s,
  popover: c,
  isFormSubmitted: i,
  isValid: d,
  showError: o,
  errorMessage: u,
  label: f,
  labelAfter: A,
  labelCol: M,
  name: b,
  required: h,
  inlineEdit: m,
  setValue: N,
  translate: v
}) => {
  const y = "mta.fileUpload.", [x, Y] = E([]), [P, L] = E(!1), [B, F] = E(!1), Q = X(() => l / 1024 / 1024, [l]), I = X(
    (C) => {
      if (C[0]) {
        if (C[0].size > l) {
          L(!0);
          return;
        }
        if (s && !s(C[0].name)) {
          F(!0);
          return;
        }
        Y((S) => {
          const z = [...S, C[0]];
          return L(!1), F(!1), e && n(z, N), e ? [] : z;
        });
      }
    },
    [l, s, e, n, N]
  ), V = X(() => {
    n(x, N), e && Y([]);
  }, [x, n, N, e]), ie = X(() => {
    Y([]);
  }, []), Z = X((C) => {
    Y((S) => S.length === 1 ? [] : S.filter((z, se) => se !== C));
  }, []);
  return /* @__PURE__ */ t(
    q,
    {
      component: /* @__PURE__ */ g(T, { children: [
        /* @__PURE__ */ t("div", { className: m ? "popover-file-upload-inline" : "popover-file-upload", children: /* @__PURE__ */ t(et, { onDrop: I, noClick: !0, children: ({ getRootProps: C, getInputProps: S }) => /* @__PURE__ */ t("section", { style: En, children: /* @__PURE__ */ g("label", { ...C({ className: "dropzone" }), children: [
          /* @__PURE__ */ t("input", { ...S() }),
          /* @__PURE__ */ t("p", { children: v && v(`${y}dropzone`) })
        ] }) }) }) }),
        !e && x.length > 0 && /* @__PURE__ */ g("div", { children: [
          /* @__PURE__ */ g("div", { children: [
            v && v(`${y}uploaded`, { uploadedTotal: x.length }),
            x.length > 1 && /* @__PURE__ */ t(G, { className: "btn_sec_red ml-1", onClick: ie, children: v && v(`${y}removeAll`) })
          ] }),
          /* @__PURE__ */ g(fe, { children: [
            /* @__PURE__ */ t("thead", { children: /* @__PURE__ */ t("tr", { children: /* @__PURE__ */ t("th", { children: v && v(`${y}summary.name`) }) }) }),
            /* @__PURE__ */ t("tbody", { children: x.map((C, S) => /* @__PURE__ */ g("tr", { children: [
              /* @__PURE__ */ t("td", { children: C.name }),
              /* @__PURE__ */ t("td", { children: /* @__PURE__ */ t("a", { className: "icon-delete", onClick: () => Z(S) }) })
            ] }, S)) })
          ] }),
          /* @__PURE__ */ t(ht, { className: "float-xs-right", onClick: V, secondary: !0, style: { margin: "15px 0" }, children: v && v(`${y}add`) })
        ] }),
        P && /* @__PURE__ */ t(
          Se,
          {
            header: v && v(`${y}maxSizeExceeded`, { maxFileSize: Q() })
          }
        ),
        B && /* @__PURE__ */ t(Se, { header: v && v(`${y}invalidExtension`) }),
        e && r && /* @__PURE__ */ g(R, { children: [
          /* @__PURE__ */ t("div", { className: "col-xs-8" }),
          /* @__PURE__ */ t("div", { className: "col-xs-12", children: /* @__PURE__ */ t(ne, {}) })
        ] }),
        e && a && a.length > 0 && /* @__PURE__ */ g("div", { children: [
          /* @__PURE__ */ t("div", { children: v && v(`${y}summary.title`) }),
          /* @__PURE__ */ g(fe, { children: [
            /* @__PURE__ */ t("thead", { children: /* @__PURE__ */ t("tr", { children: /* @__PURE__ */ t("th", { children: v && v(`${y}summary.name`) }) }) }),
            /* @__PURE__ */ t("tbody", { children: a.map((C, S) => /* @__PURE__ */ t("tr", { children: /* @__PURE__ */ t("td", { children: C.name }) }, S)) })
          ] })
        ] })
      ] }),
      errorMessage: i && o ? u : void 0,
      label: f,
      labelAfter: A,
      labelCol: M,
      name: b,
      labelInfo: h ? "Kohustuslik" : void 0,
      labelStyle: h && i && !d ? "label-comment-error" : void 0,
      inline: m,
      popover: c
    }
  );
}, Al = O(kn), Ml = ({ children: e, label: l, className: n }) => /* @__PURE__ */ t("a", { className: D("icon-copy", n), children: l || e }), vl = ({ title: e, children: l }) => /* @__PURE__ */ g(
  "section",
  {
    style: {
      border: "2px solid #f2f3f3",
      borderRadius: "5px",
      marginBottom: "1rem"
    },
    children: [
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            marginTop: "-13px",
            marginBottom: "1rem"
          },
          children: /* @__PURE__ */ t(
            "h5",
            {
              style: {
                backgroundColor: "white",
                padding: "0 5px",
                marginLeft: "20px",
                display: "inline-block",
                fontSize: "15px",
                color: "#5d6071"
              },
              children: e
            }
          )
        }
      ),
      /* @__PURE__ */ t("div", { children: l })
    ]
  }
), Nl = ({
  buttons: e,
  defaultActiveTab: l = 0,
  headers: n,
  contents: r,
  onChangeTab: a,
  statuses: s,
  form: c = !1,
  activeTab: i,
  toggle: d,
  isHeaderHidden: o
}) => {
  const [u, f] = E(l);
  U(() => {
    A(l);
  }, []);
  const A = d || ((b) => {
    u !== b && (f(b), a?.(b));
  }), M = i !== void 0 && i > -1 ? i : u;
  return n.length !== r.length ? (console.error("number of tab headers should be equal to number of content panels"), /* @__PURE__ */ t("div", {})) : /* @__PURE__ */ g("div", { children: [
    !o && /* @__PURE__ */ g(ye, { className: D({ "form-nav": c, "mta-tabs": !c }), tabs: !0, children: [
      n.map((b, h) => {
        const m = D({
          active: M === h,
          complete: !s || s?.[h] === "complete",
          error: s?.[h] === "error",
          warning: s?.[h] === "warning",
          locked: s?.[h] === "locked"
        });
        return /* @__PURE__ */ t(K, { children: /* @__PURE__ */ t(W, { href: "javascript:void(0);", className: m, onClick: () => A(h), children: b }) }, h);
      }),
      e && /* @__PURE__ */ t("div", { style: { display: "flex", marginLeft: "auto" }, className: "hide-under-lg", children: e })
    ] }),
    e && /* @__PURE__ */ t("div", { style: { display: "flex", marginLeft: "auto" }, className: "hide-over-lg", children: e }),
    /* @__PURE__ */ t(tt, { activeTab: M, children: r.map((b, h) => /* @__PURE__ */ t(nt, { tabId: h, children: b }, h)) })
  ] });
}, Il = ({ disabled: e, children: l }) => {
  const n = (r) => k.Children.map(r, (a) => {
    if (k.isValidElement(a)) {
      const s = { disabled: !0 };
      if (a.props)
        return s.children = n(a.props.children), k.cloneElement(a, s);
    }
  });
  return /* @__PURE__ */ t("div", { children: e ? n(l) : l });
}, yl = ({ children: e, className: l, content: n, inverted: r, level: a }) => {
  const s = `h${a}`, c = D({ "text-white": r }, l);
  return /* @__PURE__ */ t(s, { className: c || void 0, children: n || e });
}, Cl = ({
  disabled: e,
  label: l,
  labelCol: n,
  locale: r = "et",
  value: a = { code: "1" }
}) => {
  const s = [{ code: "", month: "" }], i = {
    et: [
      { code: "1", month: "Jaanuar" },
      { code: "2", month: "Veebruar" },
      { code: "3", month: "Märts" },
      { code: "4", month: "Aprill" },
      { code: "5", month: "Mai" },
      { code: "6", month: "Juuni" },
      { code: "7", month: "Juuli" },
      { code: "8", month: "August" },
      { code: "9", month: "September" },
      { code: "10", month: "Oktoober" },
      { code: "11", month: "November" },
      { code: "12", month: "Detsember" }
    ],
    en: [
      { code: "1", month: "January" },
      { code: "2", month: "February" },
      { code: "3", month: "March" },
      { code: "3", month: "April" },
      { code: "5", month: "May" },
      { code: "6", month: "June" },
      { code: "7", month: "July" },
      { code: "8", month: "August" },
      { code: "9", month: "September" },
      { code: "10", month: "October" },
      { code: "11", month: "November" },
      { code: "12", month: "December" }
    ],
    ru: [
      { code: "1", month: "январь" },
      { code: "2", month: "февраль" },
      { code: "3", month: "март" },
      { code: "4", month: "апрель" },
      { code: "5", month: "май" },
      { code: "6", month: "июнь" },
      { code: "7", month: "июль" },
      { code: "8", month: "август" },
      { code: "9", month: "сентябрь" },
      { code: "10", month: "октябрь" },
      { code: "11", month: "ноябрь" },
      { code: "12", month: "декабрь" }
    ]
  }[r];
  for (const d in i)
    Object.hasOwn(i, d) && (s[d] = i[d]);
  return /* @__PURE__ */ t(
    He,
    {
      disabled: e,
      label: l,
      labelCol: n,
      labelKey: "month",
      name: "month",
      options: s,
      value: a,
      valueKey: "code"
    }
  );
}, wl = ({ form: e, buttons: l }) => /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(ye, { className: D({ "form-nav": e, "mta-tabs": !e }), tabs: !0, children: /* @__PURE__ */ t("div", { style: { display: "flex", marginLeft: "auto" }, children: l }) }) }), El = () => /* @__PURE__ */ t(
  "div",
  {
    style: {
      backgroundColor: "black",
      height: "100%",
      left: 0,
      opacity: 0.5,
      position: "fixed",
      top: 0,
      width: "100%",
      zIndex: 1100
    }
  }
), Sn = (e) => {
  const l = e.split(" ");
  return l[0][0] + l[1][0];
}, xn = (e) => {
  const l = e.split(" ");
  return l.splice(l.length - 1, 1), l.join(" ");
}, Yn = (e) => {
  const l = e.split(" ");
  return l[l.length - 1];
}, Te = ({ className: e, count: l = 0, onClick: n }) => /* @__PURE__ */ t(W, { className: e, onClick: n, children: l > 0 && /* @__PURE__ */ t("span", { className: "unread", children: l }) }), kl = ({
  customMenuItems: e,
  messagesCount: l,
  notificationsCount: n,
  onFavorite: r,
  onHelp: a,
  onLogin: s,
  onLogout: c,
  onSwitchLocale: i,
  onViewMessages: d,
  onViewNotifications: o,
  personName: u,
  toggleSidebar: f,
  isLoggedIn: A,
  isLoading: M
}) => /* @__PURE__ */ g(lt, { light: !0, className: "navbar-toggleable-xl", container: !1, children: [
  /* @__PURE__ */ t("div", { className: "navbar-header", children: /* @__PURE__ */ g(
    at,
    {
      onClick: f,
      "aria-controls": "global-menu",
      "aria-expanded": "false",
      "aria-label": "Ava/sulge menüü",
      children: [
        /* @__PURE__ */ t("span", {}),
        /* @__PURE__ */ t("span", {}),
        /* @__PURE__ */ t("span", {})
      ]
    }
  ) }),
  /* @__PURE__ */ t("h1", { className: "h3", style: { marginLeft: "10px" }, children: "RIIGI KINNISVARAREGISTER" }),
  e,
  /* @__PURE__ */ g(ye, { className: "navbar-right", navbar: !0, children: [
    i && /* @__PURE__ */ g(T, { children: [
      /* @__PURE__ */ t(K, { className: "nav-item-desktop-only", children: /* @__PURE__ */ t(W, { className: "nav-language link-gray", onClick: () => i("et"), children: "Eesti keeles" }) }),
      /* @__PURE__ */ t(K, { className: "nav-item-desktop-only", children: /* @__PURE__ */ t(W, { className: "nav-language link-gray", onClick: () => i("en"), children: "In English" }) }),
      /* @__PURE__ */ t(K, { className: "nav-item-desktop-only", children: /* @__PURE__ */ t(W, { className: "nav-language link-gray", onClick: () => i("ru"), children: "На русском" }) })
    ] }),
    d && /* @__PURE__ */ t(K, { className: "nav-item-desktop-only", children: /* @__PURE__ */ t(Te, { className: "nav-messages", count: l, onClick: d }) }),
    o && /* @__PURE__ */ t(K, { children: /* @__PURE__ */ t(Te, { className: "nav-notifications", count: n, onClick: o }) }),
    r && /* @__PURE__ */ t(K, { children: /* @__PURE__ */ t(W, { className: "nav-favourites", onClick: r }) }),
    a && /* @__PURE__ */ t(K, { className: "nav-item-desktop-only", children: /* @__PURE__ */ t(W, { className: "nav-help-center", onClick: a, tabIndex: 0 }) }),
    u && /* @__PURE__ */ t(K, { className: "nav-item-shrink-desktop", children: /* @__PURE__ */ g(W, { className: "nav-user", children: [
      /* @__PURE__ */ t("div", { className: "avatar", children: Sn(u) }),
      /* @__PURE__ */ g("div", { className: "nav-user-name nav-item-desktop-only", children: [
        /* @__PURE__ */ t("span", { className: "nav-user-first-name", children: xn(u) }),
        /* @__PURE__ */ t("span", { className: "nav-user-last-name", children: Yn(u) })
      ] })
    ] }) }),
    M ? /* @__PURE__ */ t(K, { className: "nav-logout", children: /* @__PURE__ */ t(ne, { delay: 200, size: 20 }) }) : A ? /* @__PURE__ */ t(K, { className: "nav-logout", children: /* @__PURE__ */ t("a", { href: "javascript:void(0);", className: "btn btn-logout", onClick: c, children: "Väljun" }) }) : /* @__PURE__ */ t(K, { className: "nav-logout", children: /* @__PURE__ */ t("a", { href: "javascript:void(0);", className: "btn btn-login", onClick: s, children: "Sisene" }) })
  ] })
] }), Sl = ({
  globalMenuItems: e,
  selectGlobalMenuLink: l,
  setSidebarOpen: n,
  sidebarItems: r,
  selectedTopic: a
}) => /* @__PURE__ */ t("ul", { className: "global-menu", id: "global-menu", children: e.map((s, c) => /* @__PURE__ */ t("li", { children: /* @__PURE__ */ t(
  re,
  {
    title: s.name,
    to: s.linkTo,
    onClick: () => {
      c !== a && l(c), n(r[c].topicItems.length > 0);
    },
    className: s.icon,
    children: /* @__PURE__ */ t("span", { className: "global-menu-item-overflow", children: s.name })
  }
) }, c)) }), xl = ({
  labels: e,
  values: l,
  labelSize: n = 7,
  isSplit: r,
  hasThreeCols: a,
  isSingleRow: s
}) => {
  const c = e.map((i, d) => ({
    label: i,
    value: l[d]
  }));
  if (r) {
    const i = Math.ceil(c.length / 2), d = c.slice(0, i), o = c.slice(i);
    return /* @__PURE__ */ t(R, { children: /* @__PURE__ */ t(w, { children: d.map((u, f) => /* @__PURE__ */ g(R, { className: "label-value-pair-row", children: [
      /* @__PURE__ */ t(w, { sm: 10, lg: n, className: "pr-2", children: /* @__PURE__ */ t("b", { children: d[f]?.label }) }),
      /* @__PURE__ */ t(w, { className: "pl-2", children: d[f]?.value }),
      /* @__PURE__ */ t(w, { sm: 10, lg: n, className: "pr-2", children: /* @__PURE__ */ t("b", { children: o[f]?.label }) }),
      /* @__PURE__ */ t(w, { className: "pl-2", children: o[f]?.value })
    ] }, f)) }) });
  }
  if (a) {
    const i = Math.ceil(c.length / 3), d = c.length % 3 === 1 ? i * 2 - 1 : i * 2, o = c.slice(0, i), u = c.slice(i, d), f = c.slice(d);
    return /* @__PURE__ */ t(R, { children: /* @__PURE__ */ t(w, { children: o.map((A, M) => /* @__PURE__ */ g(R, { className: "label-value-pair-row", children: [
      /* @__PURE__ */ t(w, { md: n, className: "pr-md-2", children: /* @__PURE__ */ t("b", { children: o[M]?.label }) }),
      /* @__PURE__ */ t(w, { className: "pl-md-2", children: o[M]?.value }),
      /* @__PURE__ */ t(w, { md: n, className: "pr-md-2", children: /* @__PURE__ */ t("b", { children: u[M]?.label }) }),
      /* @__PURE__ */ t(w, { className: "pl-md-2", children: u[M]?.value }),
      /* @__PURE__ */ t(w, { md: n, className: "pr-md-2", children: /* @__PURE__ */ t("b", { children: f[M]?.label }) }),
      /* @__PURE__ */ t(w, { className: "pl-md-2", children: f[M]?.value })
    ] }, M)) }) });
  }
  return s ? /* @__PURE__ */ t(R, { children: /* @__PURE__ */ t(w, { children: /* @__PURE__ */ t(R, { className: "label-value-pair-row", children: e.map((i, d) => /* @__PURE__ */ t(w, { sm: 10, xl: 5, children: /* @__PURE__ */ g(R, { children: [
    /* @__PURE__ */ t(w, { className: "pr-2", style: { flex: "0 0 auto", width: "auto" }, children: /* @__PURE__ */ t("b", { children: i }) }),
    /* @__PURE__ */ t(w, { className: "pl-2", style: { flex: "0 0 auto", width: "auto" }, children: l[d] })
  ] }) }, d)) }) }) }) : /* @__PURE__ */ t(R, { children: /* @__PURE__ */ t(w, { children: e.map((i, d) => /* @__PURE__ */ g(R, { className: "label-value-pair-row", children: [
    /* @__PURE__ */ t(w, { sm: 10, lg: n, className: "pr-2", children: /* @__PURE__ */ t("b", { children: i }) }),
    /* @__PURE__ */ t(w, { className: "pl-2", children: l[d] })
  ] }, d)) }) });
}, Yl = ({ isOpen: e, toggle: l, sidebarItems: n, selectedTopic: r }) => n.map((s) => /* @__PURE__ */ t(
  "div",
  {
    className: "sidebar",
    id: "sidebar",
    "aria-haspopup": "false",
    style: e ? {} : {
      left: "-200px"
    },
    children: /* @__PURE__ */ t("div", { className: "container-fluid", children: s.topicItems.map((c, i) => /* @__PURE__ */ g("div", { className: "sidebar-section", children: [
      /* @__PURE__ */ t(
        re,
        {
          title: c.header,
          onClick: l,
          to: s.mainPath + (c.path ? c.path : ""),
          className: "sidebar-header sidebar-section-toggle",
          children: c.header
        }
      ),
      /* @__PURE__ */ t("ul", { children: c.listItems.map((d, o) => /* @__PURE__ */ t("li", { children: /* @__PURE__ */ t("a", { children: d }) }, o)) })
    ] }, i)) })
  },
  s.mainPath
))[r], Dn = "data:image/png;base64,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", Tn = "data:image/png;base64,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", Dl = ({
  className: e,
  isOfficial: l = !1,
  isTempFrame: n = !1,
  showContactInfo: r = !0,
  showEmtaLogo: a = !0,
  versionNr: s,
  footerLinks: c
}) => /* @__PURE__ */ g("footer", { className: e, children: [
  !l && (a || r) && /* @__PURE__ */ g("div", { className: "footer-top", children: [
    a && /* @__PURE__ */ t("div", { className: "footer-logo", children: /* @__PURE__ */ t("img", { alt: "Maksu- ja Tolliameti logo", src: Dn }) }),
    !n && /* @__PURE__ */ g("div", { className: "footer-quick-links", children: [
      /* @__PURE__ */ t("h2", { children: "Kiirelt kätte" }),
      /* @__PURE__ */ t("ul", { className: "list-with-arrows", children: c && c?.length > 0 && c.map((i, d) => /* @__PURE__ */ t("li", { children: /* @__PURE__ */ t("a", { className: "link-gray", href: i.link, target: "_blank", rel: "noreferrer", children: i.text }) }, i.id ?? d)) })
    ] }),
    r && /* @__PURE__ */ t("div", { children: !n && /* @__PURE__ */ g("div", { className: "footer-contact", children: [
      /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t("div", { className: "footer-contact-icon", children: /* @__PURE__ */ t("i", { className: "icon-messages" }) }) }),
      /* @__PURE__ */ g("div", { children: [
        /* @__PURE__ */ t("h3", { children: "Kasutajatugi" }),
        /* @__PURE__ */ t("table", { className: "footer-business-hours", children: /* @__PURE__ */ g("tbody", { children: [
          /* @__PURE__ */ g("tr", { children: [
            /* @__PURE__ */ t("td", { className: "text-muted", children: "E-post:" }),
            /* @__PURE__ */ t("td", { children: "kvr@fin.ee" })
          ] }),
          /* @__PURE__ */ g("tr", { children: [
            /* @__PURE__ */ t("td", { className: "text-muted", children: "Telefon:" }),
            /* @__PURE__ */ t("td", { children: "6113046" })
          ] }),
          /* @__PURE__ */ g("tr", { children: [
            /* @__PURE__ */ t("td", { className: "text-muted", children: "Tööaeg:" }),
            /* @__PURE__ */ t("td", { children: "E-R 9.00- 18.00" })
          ] })
        ] }) })
      ] })
    ] }) })
  ] }),
  /* @__PURE__ */ t("div", { className: "footer-bottom", children: /* @__PURE__ */ g("div", { className: "footer-bottom-container", children: [
    /* @__PURE__ */ t("div", { className: "footer-bottom-flags", children: /* @__PURE__ */ t("img", { alt: "Euroopa regionaalarengu fondi logo", src: Tn }) }),
    /* @__PURE__ */ t("div", { className: "footer-bottom-text", style: { textAlign: "right" }, children: /* @__PURE__ */ t("p", { children: s }) })
  ] }) })
] }), Bn = {
  et: {
    title: "Sessioon on aegunud",
    description: "Kui soovite e-maksuameti/e-tolli teenuste kasutamist jätkata, sisenege palun uuesti.",
    buttonText: "Sisenen"
  },
  en: {
    title: "The session has expired",
    description: "If you would like to continue using e-Tax/e-Customs, please sign in again.",
    buttonText: "Sign in"
  },
  ru: {
    title: "Время работы сессии закончилось",
    description: "Если Вы желаете продолжить пользоваться услугами э-налогового департамента/э-таможни, пожалуйста, войдите заново.",
    buttonText: "Войти"
  }
}, Tl = ({ locale: e = "et", onRedirect: l }) => {
  const n = Bn[e];
  return U(() => (document.body.classList.add("session-ended"), () => {
    document.body.classList.remove("session-ended");
  }), []), /* @__PURE__ */ t("div", { className: "page-wrapper", children: /* @__PURE__ */ g("section", { children: [
    /* @__PURE__ */ t("h2", { children: n.title }),
    /* @__PURE__ */ g("div", { className: "section", children: [
      /* @__PURE__ */ t("p", { children: n.description }),
      /* @__PURE__ */ t(G, { label: n.buttonText, onClick: l })
    ] })
  ] }) });
}, Rn = {
  et: {
    title: "Sessioon on lõppenud",
    description: "Turvalisuse huvides sulgege palun veebilehitseja aken."
  },
  en: {
    title: "The session has ended",
    description: "Please close your web browser window for security."
  },
  ru: {
    title: "Сессия закончена",
    description: "В интересах безопасности, пожалуйста, закройте окно браузера."
  }
}, Bl = ({ locale: e = "et" }) => {
  const l = Rn[e];
  return U(() => (document.body.classList.add("session-ended"), () => {
    document.body.classList.remove("session-ended");
  }), []), /* @__PURE__ */ t("div", { className: "page-wrapper", children: /* @__PURE__ */ g("section", { children: [
    /* @__PURE__ */ t("h2", { children: l.title }),
    /* @__PURE__ */ t("div", { className: "section", children: /* @__PURE__ */ t("p", { children: l.description }) })
  ] }) });
};
export {
  fl as AddressInputField,
  dl as AsyncSelectField,
  el as AutocompleteField,
  El as Backdrop,
  G as Button,
  Ln as ButtonAdd,
  wl as ButtonBar,
  jn as ButtonCancel,
  Kn as ButtonChange,
  ct as ButtonDelete,
  dt as ButtonDeleteRow,
  mt as ButtonEditRow,
  Hn as ButtonFloatEdit,
  Ol as ButtonGroup,
  ut as ButtonIcon,
  Gn as ButtonInspectRow,
  Xn as ButtonOneWayAdd,
  Ce as ButtonOutline,
  Jn as ButtonPrint,
  Un as ButtonResetRow,
  ht as ButtonSave,
  Qn as ButtonSaveRow,
  ft as ButtonStatusBlue,
  pn as ButtonStatusGray,
  zn as ButtonStatusGreen,
  qe as ButtonStatusOrange,
  gt as ButtonStatusRed,
  Zn as ButtonStatusYellow,
  tl as ButtonsWrapper,
  bt as CenteredBlock,
  Le as Checkbox,
  nl as CheckboxField,
  ll as CheckboxGroup,
  w as Col,
  Vl as Collapse,
  ot as ConfirmationModal,
  ql as Container,
  al as CurrencyField,
  Kt as DatePicker,
  Ne as DatePickerField,
  Il as Disabled,
  Wn as DownloadLink,
  $n as DraggableArea,
  _n as DraggableSection,
  Se as ErrorBlock,
  q as FieldWrapper,
  Ae as FieldsetWrapper,
  Al as FileUploadSection,
  Dl as Footer,
  Pl as Form,
  Ll as FormGroup,
  Sl as GlobalMenu,
  yl as Heading,
  sl as InlineGroup,
  $ as Input,
  zt as InputField,
  Ie as Label,
  xl as LabelValuePairs,
  Ml as LinkCopy,
  ne as Loader,
  vt as MessageBlock,
  vl as MiniSection,
  Je as Modal,
  pe as ModalBody,
  Ze as ModalFooter,
  ke as ModalHeader,
  Cl as MonthSelect,
  gl as MultipleChoice,
  ye as Nav,
  K as NavItem,
  W as NavLink,
  lt as Navbar,
  jl as NavbarBrand,
  kl as NavbarHeader,
  at as NavbarToggler,
  Nt as Pagination,
  H as Popover,
  rt as PopoverError,
  en as Radio,
  _t as RadioContainer,
  nn as RadioField,
  il as RangePickerWrapper,
  ol as ReactForm,
  Kl as ReactstrapTooltip,
  fe as ResponsiveTable,
  R as Row,
  Pe as Section,
  Mt as SectionSettings,
  $e as Select,
  He as SelectField,
  ml as SelectGroup,
  Bl as SessionEnded,
  Tl as SessionExpired,
  Yl as Sidebar,
  le as StatusButton,
  bl as Table,
  It as TableRow,
  xe as TableRowTools,
  mn as TableSelect,
  ul as TableSelectField,
  Nl as Tabs,
  rl as TextareaField,
  Xt as TimePicker,
  cl as TimePickerField,
  gn as Toggle,
  hl as ToggleField,
  Hl as UncontrolledTooltip
};
//# sourceMappingURL=components.es.js.map
